import React, { useState, useEffect } from "react";
import "./banner.scss";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../header/Navbar";
import Modal from "react-bootstrap/Modal";
import EthPrice from "../../../hooks/chinaFunction/ethPrice";
import UniPrice from "../../../hooks/chinaFunction/uniPrice";
import LinkPrice from "../../../hooks/chinaFunction/linkPrice";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../../../hooks/useWeb3";
import moment from "moment";
import AllowanceTpl from "../../../hooks/dataFetchers/AllowanceTpl";
import AllowanceTpl1 from "../../../hooks/dataFetchers/AllowanceTpl1";
import ApproveTpl from "../../../hooks/dataFetchers/ApproveTpl";
import ApproveTplUsdc from "../../../hooks/dataFetchers/ApproveTplUsdc";
import ApproveTplUsdc1 from "../../../hooks/dataFetchers/approveTplUsdc1";
import ApproveTplWbtc from "../../../hooks/dataFetchers/ApproveTplWbtc";
import ApproveTplWbtc1 from "../../../hooks/dataFetchers/approveTplWbtc1";
import ApproveTomi from "../../../hooks/dataFetchers/ApproveTomi";
import ApproveGems from "../../../hooks/dataFetchers/ApproveGems";
import ApproveLink from "../../../hooks/dataFetchers/ApproveLink";
import ApprovePepe from "../../../hooks/dataFetchers/ApprovePepe";
import ApproveUnisawape from "../../../hooks/dataFetchers/ApproveUniswape";
import ApproveTomi1 from "../../../hooks/dataFetchers/ApproveTomi1";
import ApproveTpl1 from "../../../hooks/dataFetchers/ApproveTpl1";
import BalacefAccount from "../../../hooks/dataFetchers/BalaceOfAccount";
import PurchaseEth from "../../../hooks/chinaFunction/purchaseEth";
import PurchaseEth1 from "../../../hooks/chinaFunction/purchaseEth1";
import PurchaseUsdt from "../../../hooks/chinaFunction/purchaseUsdt";
import PurchaseUsdc from "../../../hooks/chinaFunction/purchaseUsdc";
import PurchaseUsdc1 from "../../../hooks/chinaFunction/purchaseUsdc1";
import PurchaseWbtc from "../../../hooks/chinaFunction/purchaseWbtc";
import PurchaseWbtc1 from "../../../hooks/chinaFunction/purchaseWbtc1";
import PurchaseUsdt1 from "../../../hooks/chinaFunction/purchaseUsdt1";
import PurchasePepe from "../../../hooks/chinaFunction/purchasePepe";
import PurchaseLink from "../../../hooks/chinaFunction/purchaseLink";
import PurchaseUniswape from "../../../hooks/chinaFunction/purchaseUniswape";
import Loader from "../../../hooks/loader";
import axios from "axios";
import { API_URL } from "../../../utils/ApiUrl";
import { toast } from "react-toastify";
import CuurentRound from "../../../hooks/chinaFunction/round";
import CuurentRoundNft from "../../../hooks/chinaFunction/roundNft";
import SaleStatus from "../../../hooks/chinaFunction/saleStatus";
import SaleStatusNft from "../../../hooks/chinaFunction/saleStatusNft";
import PsMarketCap from "../../../hooks/chinaFunction/psMarketCap";
import InMarketCap from "../../../hooks/chinaFunction/inMarketCap";
import SaleStatus1 from "../../../hooks/chinaFunction/saleStatus1";
import InTotalPurchase from "../../../hooks/chinaFunction/inTotalPurchase";
import PsTotalPurchase from "../../../hooks/chinaFunction/psTotalPurchase";
import Timer from "../../../hooks/chinaFunction/timer";
import TimerNft from "../../../hooks/chinaFunction/timeNft";
import { useHistory } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DopNft from "../../DopNft/DopNft";
import BalacefAccountTomi from "../../../hooks/dataFetchers/BlanaceOfAccountTom";
import BalacefAccountGems from "../../../hooks/dataFetchers/BlanaceOfAccountGems";
import BalacefAccountLink from "../../../hooks/dataFetchers/BalacefAccountLink";
import BalacefAccountPepe from "../../../hooks/dataFetchers/BalacefAccountPepe";
import BalacefAccountUni from "../../../hooks/dataFetchers/BalacefAccountUni";
import BalacefAccountUsdc from "../../../hooks/dataFetchers/BalanceOfAccountUsdc";
import BalacefAccountWbtc from "../../../hooks/dataFetchers/BalanceOfAccountWbtc";
import AllowanceTomi from "../../../hooks/dataFetchers/AllowanceTomi";
import AllowanceGems from "../../../hooks/dataFetchers/AllowanceGems";
import AllowanceLink from "../../../hooks/dataFetchers/AllowanceLink";
import AllowancePepe from "../../../hooks/dataFetchers/AllowancePepe";
import AllowanceUniswape from "../../../hooks/dataFetchers/AllowanceUniswape";
import AllowanceUsdc from "../../../hooks/dataFetchers/AllowanceUsdc";
import AllowanceUsdc1 from "../../../hooks/dataFetchers/AllowanceUsdc1";
import AllowanceWbtc from "../../../hooks/dataFetchers/AllowanceWbtc";
import AllowanceWbtc1 from "../../../hooks/dataFetchers/AllowanceWbtc1";
import AllowanceTomi1 from "../../../hooks/dataFetchers/AllowanceTomi1";
import PurchaseTomi from "../../../hooks/chinaFunction/purchaseTomi";
import PurchaseTomi1 from "../../../hooks/chinaFunction/puchaseTomi1";
import DiscountedPrice from "../../../hooks/chinaFunction/discountedPrice";
import Environment from "../../../utils/Environment";
import WbtcPrice from "../../../hooks/chinaFunction/wbtcPrice";
import AllowanceDop from "../../../hooks/dataFetchers/AllowanceDop";
import ApproveDop from "../../../hooks/dataFetchers/ApproveDop";
import PurchaseDop from "../../../hooks/chinaFunction/purchaseDop";
import AllowanceDop1 from "../../../hooks/dataFetchers/AllowanceDop1";
import ApproveDop1 from "../../../hooks/dataFetchers/ApproveDop1";
import PurchaseDop1 from "../../../hooks/chinaFunction/purchaseDop1";
import BalacefAccountDop from "../../../hooks/dataFetchers/balanceOfAccountDop";
import { setupNetwork } from "../../../utils/wallet";
import GetGemsStakedIndex from "../../../hooks/chinaFunction/getGemsStakedIndex";
import GetGemsStaked from "../../../hooks/chinaFunction/getGemsStakeAmount";
import { storeReferrer } from "@sharemint/sdk";
import PurchaseGems from "../../../hooks/chinaFunction/purchaseGems";
import PurchaseGems1 from "../../../hooks/chinaFunction/purchaseGems1";
import AllowanceGems1 from "../../../hooks/dataFetchers/AllowanceGems1";
import ApproveGems1 from "../../../hooks/dataFetchers/ApproveGems1";
import InsurancePercentage from "../../../hooks/dataFetchers/insurancePercentage";
import useRecordEvent from "../../../hooks/useRecordEvent";
import RoundTimer from "./RoundTimer";
import useWeb3ErrorToast, {
  generateToast,
} from "../../../utils/useWeb3ErrorToast";
import Footer from "../Footer/Footer";
import useAuth from "../../../hooks/useAuth";
import {
  clearWalletSession,
  setWalletSession,
} from "../../../utils/walletSession";
import { requestWithState } from "../../../@api/requestWithState";
import { notifyInfo } from "../../Toast";
import { getGemsTokenContract } from "../../../utils/contractHelpers";

const CHAIN = process.env.REACT_APP_CHAIN_ID;

const Banner = ({ setShow }) => {
  // let sharemintValue = localStorage.getItem("sharemint");
  let ipBuyer = localStorage.getItem("ip");
  let countryBuyer = localStorage.getItem("country");
  const Presale = Environment?.presale;
  const { login, logout } = useAuth();
  const { recordEvent } = useRecordEvent();
  const { handleError } = useWeb3ErrorToast();
  const [checkBoxx, setCheckBoxx] = useState(false);
  const [insurancePer, setInsurancePer] = useState(0);
  // const { allowanceDop } = AllowanceDop();
  // const { allowanceDop1 } = AllowanceDop1();
  const { approveDop } = ApproveDop();
  const { approveDop1 } = ApproveDop1();
  const { purchaseDop } = PurchaseDop();
  const { purchaseDop1 } = PurchaseDop1();
  // const { balacefAccountDop } = BalacefAccountDop();
  const history = useHistory();
  const { getGemsStaked } = GetGemsStaked();
  // const { getGemsStakedIndex } = GetGemsStakedIndex();
  // const { allowanceLink } = AllowanceLink();
  // const { allowanceTomi } = AllowanceTomi();
  const { allowanceGems } = AllowanceGems();
  // const { allowancePepe } = AllowancePepe();
  // const { allowanceUniswape } = AllowanceUniswape();
  const { allowanceUsdc } = AllowanceUsdc();
  // const { allowanceWbtc } = AllowanceWbtc();
  // const { allowanceUsdc1 } = AllowanceUsdc1();
  // const { allowanceWbtc1 } = AllowanceWbtc1();
  // const { allowanceTomi1 } = AllowanceTomi1();
  const { cuurentRound } = CuurentRound();
  // const { cuurentRoundNft } = CuurentRoundNft();
  const { saleStatus } = SaleStatus();
  // const { saleStatusNft } = SaleStatusNft();
  // const { insurancePercentage } = InsurancePercentage();
  // const { psMarketCap } = PsMarketCap();
  // const { inMarketCap } = InMarketCap();
  // const { psTotalPurchase } = PsTotalPurchase();
  // const { inTotalPurchase } = InTotalPurchase();
  // const { saleStatus1 } = SaleStatus1();
  const { timer } = Timer();
  const { timerNft } = TimerNft();
  const { purchaseTomi } = PurchaseTomi();
  const { purchaseGems } = PurchaseGems();
  const { approveGems1 } = ApproveGems1();
  const { purchaseGems1 } = PurchaseGems1();
  // const { allowanceGems1 } = AllowanceGems1();
  const [gemsAllowance1, setGemsAllwance1] = useState(null);
  const { purchaseTomi1 } = PurchaseTomi1();
  const { discountedPrice } = DiscountedPrice();
  const [psTotlaPurchasess, setPsTotlaPurchasess] = useState(null);
  const [inTotlaPurchasess, setInTotlaPurchasess] = useState(null);
  const [psmyTotlaPurchasess, setMyPsTotlaPurchasess] = useState(null);
  const [inMyTotlaPurchasess, setMyInTotlaPurchasess] = useState(null);
  const [psMaxxCap, setPsMaxxCap] = useState(null);
  // const [inMaxxCap, setInMaxxCap] = useState(null);
  const [stakeEndTime, setStakeEndTime] = useState([]);
  const [stakingData, setStakingData] = useState([]);
  var now11 = new Date();
  let createdDate = now11?.getTime();

  useEffect(() => {
    storeReferrer();
    return () => {};
  }, []);
  // console.log(createdDate,'createdDate');
  // const capHandler = async () => {
  //   try {

  //     // const { psMarketCap } = PsMarketCap()
  //     // const { inMarketCap } = InMarketCap()
  //     // const { psTotalPurchase } = PsTotalPurchase()
  //     // const { inTotalPurchase } = InTotalPurchase()
  //     let a = await psMarketCap()
  //     setPsMaxxCap(a)
  //     let b = await inMarketCap()
  //     setInMaxxCap(b)
  //     let c = await psTotalPurchase()
  //     setPsTotlaPurchasess(c)
  //     let v = await inTotalPurchase()
  //     setInTotlaPurchasess(v)
  //     // console.log(a,b,v,c,'total cap');
  //   } catch (err) {
  //     console.log(err, 'err from cap');

  //   }
  // }
  // // console.log(psMaxxCap,psmyTotlaPurchasess,'nooooooooor',psTotlaPurchasess);
  let currentTime = createdDate / 1000;
  currentTime = parseInt(currentTime);
  const objjjj = localStorage?.getItem("oobjj");
  const code = localStorage?.getItem("accessCode");
  const instiPrice = localStorage?.getItem("price_ins");
  const role = localStorage?.getItem("role_ins");
  const modalTwitter = localStorage?.getItem("twittter");
  const startTime11 = localStorage?.getItem("timeeee");
  const [id, setId] = useState(null);
  const [price, setPrice] = useState(null);
  const [round, setRound] = useState(null);
  const [loaderr, setLoarder] = useState(false);
  const [loaderr1, setLoarder1] = useState(false);
  const { purchaseUsdt } = PurchaseUsdt();
  const { purchaseUsdc } = PurchaseUsdc();
  const { purchaseUsdc1 } = PurchaseUsdc1();
  const { purchaseWbtc } = PurchaseWbtc();
  const { purchaseWbtc1 } = PurchaseWbtc1();
  const { purchasePepe } = PurchasePepe();
  const { purchaseLink } = PurchaseLink();
  const { purchaseUniswape } = PurchaseUniswape();
  const { purchaseEth } = PurchaseEth();
  const { purchaseUsdt1 } = PurchaseUsdt1();
  const { purchaseEth1 } = PurchaseEth1();
  const { approveTpl } = ApproveTpl();
  const { approveTplUsdc } = ApproveTplUsdc();
  const { approveTplwbtc } = ApproveTplWbtc();
  const { approveTplUsdc1 } = ApproveTplUsdc1();
  const { approveTplwbtc1 } = ApproveTplWbtc1();
  const { approveTomi } = ApproveTomi();
  const { approveGems } = ApproveGems();
  const { approveLink } = ApproveLink();
  const { approvePepe } = ApprovePepe();
  const { approveUnisawape } = ApproveUnisawape();
  const { approveTomi1 } = ApproveTomi1();
  const { approveTpl1 } = ApproveTpl1();
  const { allowanceTpl } = AllowanceTpl();
  const { allowanceTpl1 } = AllowanceTpl1();
  const { balacefAccount } = BalacefAccount();
  const { balacefAccountTomi } = BalacefAccountTomi();
  const { balacefAccountGems } = BalacefAccountGems();
  const { balacefAccountLink } = BalacefAccountLink();
  const { balacefAccountUni } = BalacefAccountUni();
  const { balacefAccountPepe } = BalacefAccountPepe();
  const { balacefAccountUsdc } = BalacefAccountUsdc();
  const { balacefAccountWbtc } = BalacefAccountWbtc();
  const [currentRoundd, setCurrentRoundd] = useState(null);
  const [copyOfPrice, setCopyOfPrice] = useState(null);
  const [priceCheck, setPriceCheck] = useState(false);
  const web3 = useWeb3();
  let now = Date.now();
  const { ethPrice } = EthPrice();
  // const { linkPrice } = LinkPrice();
  // const { uniPrice } = UniPrice();
  // const { wbtcPrice } = WbtcPrice();
  const [inputFeild5, setInputField5] = useState(null);
  const [inputFeild, setInputField] = useState(null);
  const [inputFeild1, setInputField1] = useState(null);
  const [ethPricevalue, setEthPrice] = useState(0);
  const [uniPricevalue, setUniPrice] = useState(0);
  const [dopPricevalue, setDopPrice] = useState(0);
  const [linkPricevalue, setlinkPrice] = useState(0);
  const [blanceOfEth, setBlanceOfEth] = useState(0);
  const [date, setDate] = useState(0);
  const [mainTag, setMainTag] = useState("ETH");
  const [mainTag1, setMainTag1] = useState("USDT");
  const { account, chainId } = useWeb3React();
  const [balanceeUsdt, setBalanceeUsdt] = useState(null);
  const [sallowance, setAllowance] = useState(null);
  const [getAllowanceUsdc, setAllowanceUsdc] = useState(null);
  const [getAllowanceWbtc, setAllowanceWbtc] = useState(null);
  const [getAllowanceUsdc1, setAllowanceUsdc1] = useState(null);
  const [getAllowanceWbtc1, setAllowanceWbtc1] = useState(null);
  const [sallowance1, setAllowance1] = useState(null);
  const [currentRount, setCurrentRount] = useState(null);
  const [currentTimer, setCurrentTimer] = useState(null);
  const [timeshow, setTimeshow] = useState(false);

  const [saleCurrentStaus, setSaleCurrentStaus] = useState(false);
  const [saleCurrentStaus1, setSaleCurrentStaus1] = useState(false);
  const [check, setCheck] = useState(false);
  const [amountInUsdt, setAmountInUsdt] = useState(null);
  const [niceName, setNicName] = useState(null);
  // console.log(niceName,'niceName');
  const [tab, setTab] = useState("home");
  const [tagImge, setTagImge] = useState("/assets/eth-icon.svg");
  const [pepePrice, setPepePrice] = useState(0);
  const [tomiPrice, setTomiPrice] = useState(0);
  const [gemsPrice, setGemsPrice] = useState(0);
  const [gemsBalance, setGemsBalance] = useState(0);
  const [wbtcCurrentPrice, setWbtcCurrentPrice] = useState(null);
  // const [usdcCurrentPrice,setUsdcCurrentPrice]=useState(null)
  const [balaceOfTmi, setBalanceOfTomi] = useState(null);
  const [balaceOfUnii, setBalanceOfUnii] = useState(null);
  const [balaceOfDoppp, setBalanceOfDopp] = useState(null);
  const [balaceOfLinkk, setBalanceOfLinkk] = useState(null);
  const [balaceOfPepee, setBalanceOfPepee] = useState(null);
  const [balaceOfUsdc, setBalanceOfUsdc] = useState(null);
  const [balaceOfWbtc, setBalanceOfWbtc] = useState(null);
  const [tomiAllowance, setTomiAllwance] = useState(null);
  const [gemsAllowance, setGemsAllwance] = useState(null);
  const [uniAllowance, setUniAllwance] = useState(null);
  const [linkAllowance, setLinkAllwance] = useState(null);
  const [dopAllowance, setDopAllwance] = useState(null);
  const [dopAllowance1, setDopAllwance1] = useState(null);
  const [pepeAllowance, setPepeAllwance] = useState(null);
  const [tomiAllowance1, setTomiAllwance1] = useState(null);
  const [percent, setPercet] = useState(0);
  const [stakeIndex, setStakeIndux] = useState([]);
  const [stakedAmount, setStakedAmount] = useState(0);
  const [multiplyPercentNumbere, setMultiplyPercentNumbere] = useState(0);
  const [discountedPriceee, setDiscountedPriceee] = useState(0);
  const [ethValueCalcualte, setethValueCalcualte] = useState(null);
  const [stakeEndTime1, setStakeEndTime1] = useState([]);
  const [stakingData1, setStakingData1] = useState({});
  const [allowedTokens, setAllowedTokens] = useState([]);
  const [cheked3, setCheked3] = useState(false);
  const [cheked4, setCheked4] = useState(false);

  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [isNewMailRequired, setIsNewMailRequired] = useState(false);
  const [email, setEmail] = useState(null);
  const [isValidMail, setIsValidMail] = useState(true);
  const [isMailVerificationChecked, setIsMailVerificationChecked] =
    useState(false);
  const [otpRequired, setOtpRequired] = useState(false);

  const [otp, setOtp] = useState("");
  const [isCodeValid, setIsCodeValid] = useState(true);
  const [codeSentOnce, setCodeSentOnce] = useState(false);
  const [isResendDisabled, setIsResendDisabled] = useState(false);

  const [readDisclaimer, setReadDisclaimer] = useState(false);
  const [checkDisclaimer, setCheckDisclaimer] = useState(false);
  const [checkCitizenship, setCheckCitizenship] = useState(false);
  const [checkMerketing, setCheckMerketing] = useState(true);

  const [showtermsservices, setShowTermsServices] = useState(false);
  const [attemptedDisclaimer, setAttemptedDisclaimer] = useState(false);

  const handleCloseTermsServices = () => {
    setShowTermsServices(false);
  };

  const handleShowTermsServices = () => {
    setReadDisclaimer(true);
    setShowTermsServices(true);
  };

  const handleDisclaimerCheckbox = () => {
    if (!readDisclaimer) {
      setAttemptedDisclaimer(true);
      return;
    }
    setCheckDisclaimer(true);
  };

  const canBuy = checkDisclaimer && checkCitizenship;

  const [modalDelay, setModalDelay] = useState(true);

  setTimeout(() => {
    setModalDelay(false);
  }, 2000);

  const [isVerificationDone, setIsVerificationDone] = useState(true);

  const handleCloseVerification = () => setIsVerificationDone(true);
  const handleShowVerification = () => setIsVerificationDone(false);

  useEffect(() => {
    if (modalDelay) return;
    const data = localStorage.getItem("verifiedData");
    const verifiedData = data ? JSON.parse(data) : null;

    const isVerified =
      !!account &&
      verifiedData?.address.toLowerCase() === account.toLowerCase() &&
      verifiedData?.email;

    if (!account) {
      handleShowVerification();
      return;
    }

    if (isVerified) {
      handleCloseVerification();
      setEmail(verifiedData.email);
      return;
    }

    handleShowVerification();
    checkGeneralVerification();
  }, [account, modalDelay]);

  const checkGeneralVerification = async () => {
    if (!account) return;
    try {
      setLoarder1(true);
      const response = await requestWithState({
        url: `/emails/wallet-details`,
        method: "POST",
        data: {
          by: account.toLowerCase(),
        },
      });
      setLoarder1(false);
      console.log(response?.deta, "Verification Response");
      const data = response?.deta;
      if (data?.isVerified) {
        setIsEmailVerified(true);
        console.log("Verified fetched successfully:", response?.data);
        setEmail(data?.email || null);
        await callRecordEventAgreement(data?.email, true, true);
      } else {
        setIsEmailVerified(false);
        setEmail(data?.email || null);
        setIsNewMailRequired(true);
        // await callRecordEventAgreement(data?.email);
        console.log("User is not verified");
      }
    } catch (error) {
      setIsEmailVerified(false);
      setEmail(null);
      console.error("Error checking verified:", error);
    } finally {
      setLoarder1(false);
    }
  };

  const handlCheckEmailVerification = async () => {
    if (!isValidEmail(email)) {
      setIsValidMail(false);
      return;
    }

    try {
      setLoarder1(true);
      const response = await requestWithState({
        url: `/emails/email-details?email=${email}&by=${account.toLowerCase()}`,
        method: "GET",
      });

      const data = response?.deta;
      console.log(response, "Email Verification Check Response");
      if (data?.isFullyVerified) {
        await callRecordEventAgreement(email, true, true);
        handleContinueWithVerifiedMail();
      } else {
        setOtpRequired(true);
      }
    } catch (error) {
      console.error("Error checking verified:", error);
    } finally {
      setLoarder1(false);
      setIsMailVerificationChecked(true);
    }
  };

  const handleSendCode = async () => {
    if (!isValidEmail(email)) {
      setIsValidMail(false);
      return;
    }

    const url = isNewMailRequired
      ? `/emails/verify-email`
      : `/emails/update-email`;

    try {
      setLoarder1(true);
      const response = await requestWithState({
        url,
        method: isNewMailRequired ? "POST" : "PATCH",
        data: {
          by: account.toLowerCase(),
          email: email.trim(),
        },
      });

      console.log(response?.deta, "Send Code Response");

      if (response?.statusCode === 200) {
        console.log("Email already verified.");
        handleContinueWithVerifiedMail();
        await callRecordEventAgreement(email, true, true);
      } else if (response?.statusCode === 201) {
        console.log("Verification email sent.");
        setCodeSentOnce(true);
        toast.success("Verification code sent to your email", {
          className: "verification-toast",
          position: "top-right",
        });

        // Start cooldown
        setIsResendDisabled(true);
        setResendTimer(10);
      }
    } catch (error) {
      console.error("Error updating email:", error);
    } finally {
      setLoarder1(false);
    }
  };

  const handlVerifyCode = async () => {
    console.log("Verifying code:", otp, email);
    if (otp?.trim()?.length === 0 || otp?.trim()?.length !== 6) {
      setIsCodeValid(false);
      return;
    }

    try {
      setLoarder1(true);
      const response = await requestWithState({
        url: `/emails/verify-otp`,
        method: "POST",
        data: {
          email: email.trim(),
          by: account.toLowerCase(),
          otp,
        },
      });

      if (response?.statusCode === 201) {
        await callRecordEventAgreement(email, true, true);
        setIsEmailVerified(true);
        console.log("Email verified successfully");
        setIsCodeValid(true);
        handleContinueWithVerifiedMail();
      } else {
        setIsCodeValid(false);
      }
    } catch (error) {
      console.error("Error verifying code:", error);
      setIsCodeValid(false);
    } finally {
      setLoarder1(false);
    }
  };

  const [resendTimer, setResendTimer] = useState();
  useEffect(() => {
    let countdown;
    if (resendTimer > 0) {
      countdown = setTimeout(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0 && isResendDisabled) {
      setIsResendDisabled(false);
    }
    return () => clearTimeout(countdown);
  }, [resendTimer, isResendDisabled]);

  const handleContinueWithVerifiedMail = () => {
    handleCloseVerification();
    setEmail(email);
    setOtp("");
    setIsEmailVerified(false);
    setIsNewMailRequired(false);
    setIsValidMail(true);
    setIsMailVerificationChecked(false);
    setOtpRequired(false);
    setIsCodeValid(true);
    setCodeSentOnce(false);
    setIsResendDisabled(false);

    localStorage.setItem(
      "verifiedData",
      JSON.stringify({ address: account, email }),
    );
  };

  const handleContinueWithAnotherEmail = () => {
    setIsEmailVerified(false);
    setEmail(null);
  };

  const callRecordEventAgreement = async (
    email,
    emailVerified = false,
    onlyEmailEvent = false,
  ) => {
    const accessCode = localStorage.getItem("accessCode");
    if (!accessCode) return;

    const metaData = {
      ...(!onlyEmailEvent && {
        privateSaleAgreement: [
          {
            email,
            agreedToToS: checkDisclaimer,
            agreedToNotUsIsrealCitizen: checkCitizenship,
            agreedToReceiveMarketingEmail: checkMerketing,
            agreedOn: Date.now(),
          },
        ],
      }),
      ...(emailVerified && {
        emailWasVerified: true,
      }),
    };

    await recordEvent(metaData);
  };

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const handleInputMail = (e) => {
    let value = e.target.value;
    setEmail(value);
    setIsEmailVerified(null);
    setIsValidMail(true);
    setIsMailVerificationChecked(false);
    setOtpRequired(false);
    setCodeSentOnce(false);
    setIsCodeValid(true);
    setOtp("");
  };

  const fetchAllowedTokens = async () => {
    try {
      const response = await axios.get(
        `${API_URL}tokens/allowed?privateSale=${Presale?.apiTag}`,
      );

      if (response?.data?.data) {
        setAllowedTokens(response?.data?.data);
        console.log("allowed tokens", response?.data?.data);
      }
    } catch (error) {
      console.log("fetch allowed tokens error::", error);
    }
  };

  const [show2insurance1, setShow2Insurance1] = useState(false);
  const handleClose2Insurance1 = () => {
    setShow2Insurance1(false);
  };
  const handleClose2Insurance12 = () => {
    // setInsuranceCheck(true);
    setCheckBoxx(true);
    setShow2Insurance1(false);
  };
  const handleShow2Insurance1 = () => {
    setShow2Insurance1(true);
  };
  // const handleClose2Insurance1 = () => setShow2Insurance1(true);

  // const [limitObj, setLimitObj] = useState(null)
  // const [limitObjperc, setLimitObjperc] = useState(null)
  // const [gaugePosition,setGaugePosition] =useState(null);
  // console.log( stakedAmount,discountedPriceee,multiplyPercentNumbere,' Additional Tokens');

  const [show0, setShow0] = useState(false);

  const handleClos0 = async () => {
    setShow0(false);
    if (inputFeild && inputFeild1) {
      if (chainId !== parseInt(CHAIN)) {
        let ss = await setupNetwork();
        if (ss) {
          confirm();
        }
      } else {
        confirm();
      }
    }
  };
  const handleShow0 = () => setShow0(true);
  useEffect(() => {
    if (account) {
      // toast.warning(`round ddfalsdfa, ${chainId}, ${account}, ${CHAIN}`);
      firstTimeData();
      firstTimeData11();
      saleStatusss();
      alowence();
      getGemsPrice();
      fetchAllowedTokens();
      // uniPriceHandler();
      // linkPriceHnadler();
      // dopPriceHandler();
      // getPepePrice();
      // getTomiPrice();
      // getWbtcCurrentPrice();
    }
  }, [account]);
  useEffect(() => {
    // if (chainId != parseInt(CHAIN)) return;
    if (account) {
      setStakeEndTime1([]);
      balaceOf();
      firstTimeData1();
      balancerOfGems();
      balancerOfUsdc();
      fetchStakingData();
      fetchStakingData1();
      getGemsStakedAmount();
      // balancerOftomi();
      // balancerOfPepe();
      // balancerOfUni();
      // balancerOfDop();
      // balancerOfLink();
      // balancerOfWbtc();
      // StakeIndec()
    } else {
      setBalanceeUsdt(null);
      setBlanceOfEth(null);
      setBalanceOfUsdc(null);
      setGemsBalance(null);
      setStakeEndTime1([]);
      // setBalanceOfTomi(null);
      // setBalanceOfUnii(null);
      // setBalanceOfDopp(null);
      // setBalanceOfLinkk(null);
      // setBalanceOfPepee(null);
      // setBalanceOfWbtc(null);
    }
  }, [account]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     firstTimeData();
  //     firstTimeData1();
  //   }, 30000);

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [account]);

  // console.log(sallowance,'sajad',inputFeild);

  const saleStatusss = async () => {
    try {
      let b = await saleStatus();

      // let b1 = await saleStatus1();
      if (b) {
        console.log(b, "noooor imad");
        // setCurrentRoundd(b)
        // roundData(b)
        setSaleCurrentStaus(b);
        // setSaleCurrentStaus1(b1);
      }
    } catch (err) {
      console.log(err.message, "noooor imad");
    }
  };

  const firstTimeData = async () => {
    setLoarder1(true);
    try {
      let b;
      b = await cuurentRound();
      setRound(b);
      let price = 0;
      if (b) {
        if (b == 1) {
          // setMultiplyPercentNumbere(0.2);
          price = 0.2;
        } else {
          // setMultiplyPercentNumbere(0.07);
          price = 0.07;
        }
        // console.log(b, "cccccccc");
        // setCurrentRoundd(b)
        console.log("goin into roundData waleed", b, price);
        roundData(b, price);
      }
    } catch (err) {
      console.log(err.message, "nooor");
      setLoarder1(false);
    }
  };
  // console.log(ethPricevalue,'ethPricevalue');
  const firstTimeData11 = async () => {
    try {
      console.log("firstTimeData11 called");
      let a = await ethPrice();
      console.log(a, "AAA");
      if (a) {
        setEthPrice(a);
      }
    } catch (err) {
      console.log(err.message);
    }
  };
  // const uniPriceHandler = async () => {
  //   try {
  //     let a = await uniPrice();
  //     if (a) {
  //     setUniPrice(a);
  //     }
  //   } catch (err) {
  //     console.log(err.message,'aaa');
  //   }
  // };
  // const uniPriceHandler = async () => {
  //   try {
  //     const config = {
  //       method: "get",
  //       url: `${API_URL}users/uni-price`,
  //     };
  //     const postApiRes = await axios(config).then(function (response) {
  //       let qw = response?.data?.data;
  //       // setPepePrice(qw)
  //       setUniPrice(qw);
  //     });
  //   } catch (error) {
  //     console.log("coin market cap error::", error);
  //   }
  // };
  // const dopPriceHandler = async () => {
  //   try {
  //     const config = {
  //       method: "get",
  //       url: `${API_URL}users/dop-price`,
  //     };
  //     const postApiRes = await axios(config).then(function (response) {
  //       let qw = response?.data?.data;
  //       // setPepePrice(qw)
  //       setDopPrice(qw);
  //     });
  //   } catch (error) {
  //     console.log("coin market cap error::", error);
  //   }
  // };
  // const linkPriceHnadler = async () => {
  //   try {
  //     let a = await linkPrice();
  //     if (a) {
  //       setlinkPrice(a);
  //     }
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // };
  // const getPepePrice = async () => {
  //   try {
  //     const config = {
  //       method: "get",
  //       url: `${API_URL}users/pepe-price`,
  //     };
  //     const postApiRes = await axios(config).then(function (response) {
  //       // console.log(response,'response');
  //       let qw = response?.data?.data;
  //       setPepePrice(qw);
  //     });
  //   } catch (error) {
  //     console.log("coin market cap error::", error);
  //   }
  // };
  // const getTomiPrice = async () => {
  //   try {
  //     const config = {
  //       method: "get",
  //       url: `${API_URL}users/tomi-price`,
  //     };
  //     const postApiRes = await axios(config).then(function (response) {
  //       // console.log(response,'response');
  //       let qw = response?.data?.data;
  //       setTomiPrice(qw);
  //     });
  //   } catch (error) {
  //     console.log("coin market cap error::", error);
  //   }
  // };

  const getGemsPrice = async () => {
    try {
      const config = {
        method: "get",
        url: `${API_URL}users/gems-price`,
      };
      const postApiRes = await axios(config).then(function (response) {
        // console.log(response,'response');
        let qw = response?.data?.data;
        setGemsPrice(qw);
      });
    } catch (error) {
      console.log("coin market cap error::", error);
    }
  };

  const firstTimeData1 = async () => {
    try {
      var balance = await web3.eth.getBalance(account);
      setBlanceOfEth(balance / 10 ** 18);
    } catch (err) {
      console.log(err.message);
    }
  };

  // const getWbtcCurrentPrice = async () => {
  //   try {
  //     let a = await wbtcPrice();
  //     if (a) {
  //       // console.log(a,'aaa');
  //       setWbtcCurrentPrice(a);
  //     }
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // };

  const [show1, setShow1] = useState(false);
  const [buyingNetworkFee, setbuyingNetworkFee] = useState(0);

  async function getGasFeeInUSD(txHash) {
    const receipt = await web3.eth.getTransactionReceipt(txHash);
    const tx = await web3.eth.getTransaction(txHash);

    if (!receipt || !tx) {
      throw new Error("Transaction not found");
    }

    const BN = web3.utils.BN;

    const gasUsed = new BN(receipt.gasUsed);
    const gasPrice = new BN(tx.gasPrice); // effective gas price

    // gasFeeWei = gasUsed * gasPrice
    const feeInWei = gasUsed.mul(gasPrice);

    // Convert wei → ETH (string to avoid precision loss)
    const feeInEth = web3.utils.fromWei(feeInWei, "ether");

    // Convert ETH → USD
    const feeInUsd = Number(feeInEth) * ethPricevalue;
    setbuyingNetworkFee(feeInUsd);
    // return {
    //   gasUsed: receipt.gasUsed,
    //   gasPriceGwei: web3.utils.fromWei(tx.gasPrice, "gwei"),
    //   feeInEth: Number(feeInEth),
    //   feeInUsd
    // };
  }

  const handleClose = () => {
    setInputField("");
    setInputField1("");
    setMyInTotlaPurchasess(0);
    setMyPsTotlaPurchasess(0);
    setbuyingNetworkFee(0);
    setShow1(false);
  };
  const handleShow = () => setShow1(true);
  const changeTag = () => {
    if (mainTag === "ETH") {
      setMainTag("USDT");
      setMainTag1("ETH");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
      // }
    } else {
      setMainTag("ETH");
      setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    }
  };
  const changeTag1 = (e) => {
    if (e === "ETH") {
      discoundedPriceee(currentRoundd, Environment.eth);
      setMainTag("ETH");
      setTagImge("/assets/eth-icon.svg");
      // setMainTag1("ETH");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
      // }
    } else if (e == "USDT") {
      discoundedPriceee(currentRoundd, Environment.busd);
      setMainTag("USDT");
      setTagImge("/assets/usdt.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "USDC") {
      discoundedPriceee(currentRoundd, Environment.usdc);
      setMainTag("USDC");
      setTagImge("/assets/usdc.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "WBTC") {
      discoundedPriceee(currentRoundd, Environment.wbtc);
      setMainTag("WBTC");
      setTagImge("/assets/wbtc.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "PEPE") {
      discoundedPriceee(currentRoundd, Environment.pepe);
      setMainTag("PEPE");
      setTagImge("/assets/pepe.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "DOP") {
      discoundedPriceee(currentRoundd, Environment.dop);
      setMainTag("DOP");
      setTagImge("/assets/dop.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "UNI") {
      discoundedPriceee(currentRoundd, Environment.unisape);
      setMainTag("UNI");
      setTagImge("/assets/uniswap.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "LINK") {
      discoundedPriceee(currentRoundd, Environment.link);
      setMainTag("LINK");
      setTagImge("/assets/link.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "TOMI") {
      discoundedPriceee(currentRoundd, Environment.tomi);
      setMainTag("TOMI");
      setTagImge("/assets/tomi-icon-drop.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else {
      discoundedPriceee(currentRoundd, Environment.gems);
      setMainTag("GEMS");
      setTagImge("/assets/newgemslogosvg.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    }
  };
  // const inputField1Handler = (e) => {
  //   setAmountInUsdt(0);
  //   let value = e.target.value;
  //   if (mainTag === "ETH") {
  //     if (value) {
  //       console.log(value, ethPricevalue, price);
  //       let amount = parseFloat((ethPricevalue * value) / price).toFixed(6);
  //       let amount1 = "";
  //       if (price > 0) {
  //         amount1 = Math.round(amount * 1e12) / 1e12;
  //         console.log(amount1, "amountt");
  //       } else {
  //         amount1 = 0.0;
  //       }
  //       console.log(price, "Price");
  //       setInputField1(parseFloat(amount1)?.toFixed(2));
  //       setAmountInUsdt(parseFloat(ethPricevalue * value));
  //       setInputField(value);
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       let aa = (ethPricevalue * value).toFixed(4);
  //       let vv = aa / discountedPriceee;
  //       let cc = vv - parseFloat(amount1)?.toFixed(2);
  //       setethValueCalcualte(cc);
  //       // console.log(cc.toFixed,aa,vv,discountedPriceee, 'ccccc');

  //       // (parseFloat(inputFeild) * parseFloat(ethPricevalue) / parseFloat(discountedPriceee))- (parseFloat(inputFeild1))
  //       // ?.toFixed(2)
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setethValueCalcualte(0);
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "USDT") {
  //     if (value) {
  //       let amount = parseFloat(value / price).toFixed(6);
  //       let amount1 = "";
  //       if (price > 0) {
  //         amount1 = Math.round(amount * 1e12) / 1e12;
  //       } else {
  //         amount1 = 0.0;
  //       }
  //       setInputField1(parseFloat(amount1)?.toFixed(2));
  //       setInputField(value);
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setAmountInUsdt(parseFloat(value));

  //       let aa = value;
  //       let vv = aa / discountedPriceee;
  //       let cc = vv - parseFloat(amount1)?.toFixed(2);
  //       setethValueCalcualte(cc);
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setethValueCalcualte(0);
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "USDC") {
  //     if (value) {
  //       let amount = parseFloat(value / price).toFixed(6);
  //       let amount1 = "";
  //       if (price > 0) {
  //         amount1 = Math.round(amount * 1e12) / 1e12;
  //       } else {
  //         amount1 = 0.0;
  //       }
  //       setInputField1(parseFloat(amount1)?.toFixed(2));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setInputField(value);
  //       setAmountInUsdt(parseFloat(value));
  //       let aa = value;
  //       let vv = aa / discountedPriceee;
  //       let cc = vv - parseFloat(amount1)?.toFixed(2);
  //       setethValueCalcualte(cc);
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //       setethValueCalcualte(0);
  //     }
  //   } else if (mainTag === "WBTC") {
  //     if (value) {
  //       let amount = parseFloat((wbtcCurrentPrice * value) / price).toFixed(6);
  //       let amount1 = "";
  //       if (price > 0) {
  //         amount1 = Math.round(amount * 1e12) / 1e12;
  //       } else {
  //         amount1 = 0.0;
  //       }
  //       setInputField1(parseFloat(amount1)?.toFixed(2));
  //       setAmountInUsdt(parseFloat(wbtcCurrentPrice * value));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setInputField(value);
  //       let aa = (wbtcCurrentPrice * value).toFixed(4);
  //       let vv = aa / discountedPriceee;
  //       let cc = vv - parseFloat(amount1)?.toFixed(2);
  //       setethValueCalcualte(cc);
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "UNI") {
  //     if (value) {
  //       let amount = parseFloat((uniPricevalue * value) / price).toFixed(6);
  //       let amount1 = "";
  //       if (price > 0) {
  //         amount1 = Math.round(amount * 1e12) / 1e12;
  //       } else {
  //         amount1 = 0.0;
  //       }

  //       setInputField1(parseFloat(amount1)?.toFixed(2));
  //       setAmountInUsdt(parseFloat(uniPricevalue * value));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setInputField(value);

  //       let aa = (uniPricevalue * value).toFixed(4);
  //       let vv = aa / discountedPriceee;
  //       let cc = vv - parseFloat(amount1)?.toFixed(2);
  //       setethValueCalcualte(cc);
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "LINK") {
  //     if (value) {
  //       let amount = parseFloat((linkPricevalue * value) / price).toFixed(6);
  //       let amount1 = "";
  //       if (price > 0) {
  //         amount1 = Math.round(amount * 1e12) / 1e12;
  //       } else {
  //         amount1 = 0.0;
  //       }
  //       // console.log('aasas',linkPricevalue,value,price);
  //       setInputField1(parseFloat(amount1)?.toFixed(2));
  //       setAmountInUsdt(parseFloat(linkPricevalue * value));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setInputField(value);

  //       let aa = (linkPricevalue * value).toFixed(4);
  //       let vv = aa / discountedPriceee;
  //       let cc = vv - parseFloat(amount1)?.toFixed(2);
  //       setethValueCalcualte(cc);
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "DOP") {
  //     if (value) {
  //       let amount = parseFloat((dopPricevalue * value) / price).toFixed(6);
  //       let amount1 = "";
  //       if (price > 0) {
  //         amount1 = Math.round(amount * 1e12) / 1e12;
  //       } else {
  //         amount1 = 0.0;
  //       }
  //       // console.log('aasas',linkPricevalue,value,price);
  //       setInputField1(parseFloat(amount1)?.toFixed(2));
  //       setAmountInUsdt(parseFloat(dopPricevalue * value));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setInputField(value);

  //       let aa = (dopPricevalue * value).toFixed(4);
  //       let vv = aa / discountedPriceee;
  //       let cc = vv - parseFloat(amount1)?.toFixed(2);
  //       setethValueCalcualte(cc);
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "PEPE") {
  //     if (value) {
  //       let amount = parseFloat((pepePrice * value) / price).toFixed(6);
  //       let amount1 = "";
  //       if (price > 0) {
  //         amount1 = Math.round(amount * 1e12) / 1e12;
  //       } else {
  //         amount1 = 0.0;
  //       }
  //       setInputField1(parseFloat(amount1)?.toFixed(2));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setAmountInUsdt(parseFloat(pepePrice * value));
  //       setInputField(value);

  //       let aa = (pepePrice * value).toFixed(4);
  //       let vv = aa / discountedPriceee;
  //       let cc = vv - parseFloat(amount1)?.toFixed(2);
  //       setethValueCalcualte(cc);
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "TOMI") {
  //     if (value) {
  //       let amount = parseFloat((tomiPrice * value) / price).toFixed(6);
  //       let amount1 = "";
  //       if (price > 0) {
  //         amount1 = Math.round(amount * 1e12) / 1e12;
  //       } else {
  //         amount1 = 0.0;
  //       }
  //       setInputField1(parseFloat(amount1)?.toFixed(2));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setAmountInUsdt(parseFloat(tomiPrice * value));
  //       setInputField(value);
  //       let aa = (tomiPrice * value).toFixed(4);
  //       let vv = aa / discountedPriceee;
  //       let cc = vv - parseFloat(amount1)?.toFixed(2);
  //       setethValueCalcualte(cc);
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else {
  //     if (value) {
  //       let amount = parseFloat((gemsPrice * value) / price).toFixed(6);
  //       let amount1 = "";
  //       if (price > 0) {
  //         amount1 = Math.round(amount * 1e12) / 1e12;
  //       } else {
  //         amount1 = 0.0;
  //       }
  //       setInputField1(parseFloat(amount1)?.toFixed(2));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setAmountInUsdt(parseFloat(gemsPrice * value));
  //       setInputField(value);
  //       let aa = (gemsPrice * value).toFixed(4);
  //       let vv = aa / discountedPriceee;
  //       let cc = vv - parseFloat(amount1)?.toFixed(2);
  //       setethValueCalcualte(cc);
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   }
  // };

  const inputField1Handler = (e) => {
    let raw = e.target.value;

    // Allow empty input
    if (raw === "") {
      setInputField("");
      setInputField1("");
      setethValueCalcualte(0);
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
      setAmountInUsdt(0);
      return;
    }

    // Allow typing like "0." or "."
    if (!/^\d*\.?\d*$/.test(raw)) return;

    setInputField(raw);

    const value = parseFloat(raw);
    if (isNaN(value)) return;

    let amount = 0;
    let usdValue = 0;

    if (mainTag === "ETH") {
      amount = (ethPricevalue * value) / price;
      usdValue = ethPricevalue * value;
    } else if (mainTag === "USDT" || mainTag === "USDC") {
      amount = value / price;
      usdValue = value;
    } else {
      amount = (gemsPrice * value) / price;
      usdValue = gemsPrice * value;
    }

    // High-precision normalize
    const preciseAmount = Number(amount.toPrecision(14));

    // Discount difference calc
    const discountedUnits = usdValue / discountedPriceee;
    const diff = discountedUnits - preciseAmount;

    setInputField(value);
    setInputField1(preciseAmount.toFixed(6)); // UI display only
    setAmountInUsdt(usdValue);

    setMyInTotlaPurchasess((prev) => prev + preciseAmount);
    setMyPsTotlaPurchasess((prev) => prev + preciseAmount);

    setethValueCalcualte(parseFloat(discountedUnits.toPrecision(12)));

    console.log({
      value,
      amount,
      preciseAmount,
      usdValue,
      discountedUnits,
      diff,
    });
  };

  const inputField1Handler1 = (e) => {
    let value = Number(e.target.value);

    if (!value || value <= 0) {
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
      return;
    }

    let amount = 0;

    if (mainTag === "ETH") {
      amount = (value * price) / ethPricevalue;
    } else if (mainTag === "USDT" || mainTag === "USDC") {
      amount = value * price;
    } else {
      amount = (value * price) / gemsPrice;
    }

    // Normalize precision safely
    const preciseAmount = Number(amount.toPrecision(12));

    setInputField1(value);
    setInputField(preciseAmount.toFixed(6)); // UI formatting only

    setMyInTotlaPurchasess((prev) => prev + preciseAmount);
    setMyPsTotlaPurchasess((prev) => prev + preciseAmount);

    console.log("value:", value, "amount:", amount, "precise:", preciseAmount);
  };

  // const inputField1Handler1 = (e) => {
  //   let value = e.target.value;
  //   if (mainTag === "ETH") {
  //     if (value) {
  //       let amount = parseFloat((value * price) / ethPricevalue).toFixed(6);
  //       let amount1 = Math.round(amount * 1e12) / 1e12;
  //       setInputField(parseFloat(amount1)?.toFixed(2));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setInputField1(parseFloat(value));
  //       console.log(amount, amount1, value, "amount, amount1, value");

  //       // }
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "USDT") {
  //     if (value) {
  //       let amount = parseFloat(value * price).toFixed(6);
  //       let amount1 = Math.round(amount * 1e12) / 1e12;
  //       setInputField(parseFloat(amount1)?.toFixed(2));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setInputField1(value);
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "USDC") {
  //     if (value) {
  //       let amount = parseFloat(value * price).toFixed(6);
  //       let amount1 = Math.round(amount * 1e12) / 1e12;
  //       setInputField(parseFloat(amount1)?.toFixed(2));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setInputField1(value);
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "WBTC") {
  //     if (value) {
  //       let amount = parseFloat((value * price) / wbtcCurrentPrice).toFixed(6);
  //       let amount1 = Math.round(amount * 1e12) / 1e12;
  //       setInputField(parseFloat(amount1)?.toFixed(2));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setInputField1(parseFloat(value));
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "UNI") {
  //     if (value) {
  //       let amount = parseFloat((value * price) / uniPricevalue).toFixed(6);
  //       let amount1 = Math.round(amount * 1e12) / 1e12;
  //       setInputField(parseFloat(amount1)?.toFixed(2));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setInputField1(parseFloat(value));
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "LINK") {
  //     if (value) {
  //       let amount = parseFloat((value * price) / linkPricevalue).toFixed(6);
  //       let amount1 = Math.round(amount * 1e12) / 1e12;
  //       setInputField(parseFloat(amount1)?.toFixed(2));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setInputField1(parseFloat(value));
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "DOP") {
  //     if (value) {
  //       let amount = parseFloat((value * price) / dopPricevalue).toFixed(6);
  //       let amount1 = Math.round(amount * 1e12) / 1e12;
  //       setInputField(parseFloat(amount1)?.toFixed(2));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
  //       setInputField1(parseFloat(value));
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "PEPE") {
  //     if (value) {
  //       let amount = parseFloat((value * price) / pepePrice).toFixed(6);
  //       let amount1 = Math.round(amount * 1e12) / 1e12;
  //       setInputField(parseFloat(amount1)?.toFixed(2));
  //       setInputField1(parseFloat(value));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);

  //       // }
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else if (mainTag === "TOMI") {
  //     if (value) {
  //       let amount = parseFloat((value * price) / tomiPrice).toFixed(6);
  //       let amount1 = Math.round(amount * 1e12) / 1e12;
  //       setInputField(parseFloat(amount1)?.toFixed(2));
  //       setInputField1(parseFloat(value));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);

  //       // }
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   } else {
  //     if (value) {
  //       let amount = parseFloat((value * price) / gemsPrice).toFixed(6);
  //       let amount1 = Math.round(amount * 1e12) / 1e12;
  //       setInputField(parseFloat(amount1)?.toFixed(2));
  //       setInputField1(parseFloat(value));
  //       setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
  //       setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);

  //       // }
  //     } else {
  //       setInputField1("");
  //       setInputField("");
  //       setMyInTotlaPurchasess(0);
  //       setMyPsTotlaPurchasess(0);
  //     }
  //   }
  // };

  const balaceOf = async () => {
    try {
      let balace = await balacefAccount(account);
      if (balace) {
        console.log(balace, "Balance");
        setBalanceeUsdt(balace);
      }
    } catch (err) {
      console.log(err);
    }
  };
  // const balancerOftomi = async () => {
  //   try {
  //     let balace = await balacefAccountTomi(account);
  //     if (balace) {
  //       console.log(balace, "tomi erre");
  //       setBalanceOfTomi(balace);
  //     }
  //   } catch (err) {
  //     console.log(err, "tomi erre");
  //   }
  // };
  const balancerOfGems = async () => {
    try {
      let balace = await balacefAccountGems(account);
      if (balace) {
        console.log(balace, "gems balance");
        setGemsBalance(balace);
      }
    } catch (err) {
      console.log(err, "tomi erre");
    }
  };
  // const balancerOfPepe = async () => {
  //   try {
  //     let balace = await balacefAccountPepe(account);
  //     if (balace) {
  //       setBalanceOfPepee(balace);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // const balancerOfUni = async () => {
  //   try {
  //     let balace = await balacefAccountUni(account);
  //     if (balace) {
  //       setBalanceOfUnii(balace);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // const balancerOfDop = async () => {
  //   try {
  //     let balace = await balacefAccountDop(account);
  //     if (balace) {
  //       setBalanceOfDopp(balace);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // const balancerOfLink = async () => {
  //   try {
  //     let balace = await balacefAccountLink(account);
  //     if (balace) {
  //       setBalanceOfLinkk(balace);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  const balancerOfUsdc = async () => {
    try {
      let balace = await balacefAccountUsdc(account);
      if (balace) {
        setBalanceOfUsdc(balace);
      }
    } catch (err) {
      console.log(err);
    }
  };
  // const balancerOfWbtc = async () => {
  //   try {
  //     let balace = await balacefAccountWbtc(account);
  //     if (balace) {
  //       setBalanceOfWbtc(balace);
  //     }
  //   } catch (err) {
  //     console.log(err, "sdsdsdvcv");
  //   }
  // };
  const alowence = async () => {
    try {
      // let insirance = await insurancePercentage();
      // setInsurancePer(insirance / 100);

      // let w134sr = await allowanceGems1();

      // console.log(w134sr, "Gems")
      // setGemsAllwance1(w134sr);
      // let w134s = await allowanceDop1();
      // setDopAllwance1(w134s);
      let was = await allowanceGems();
      setGemsAllwance(was);
      let r = await allowanceTpl();
      setAllowance(r);
      let usdcc = await allowanceUsdc();
      setAllowanceUsdc(usdcc);
      // let wbtcc = await allowanceWbtc();
      // setAllowanceWbtc(wbtcc);
      // let w11 = await allowanceLink();
      // setLinkAllwance(w11);
      // let w134 = await allowanceDop();
      // setDopAllwance(w134);
      // let w22 = await allowancePepe();
      // setPepeAllwance(w22);
      // let w33 = await allowanceUniswape();
      // setUniAllwance(w33);
      // let w = await allowanceTomi();
      // setTomiAllwance(w);
      // let r1 = await allowanceTpl1();
      // setAllowance1(r1);
      // let da = await allowanceTomi1();
      // setTomiAllwance1(da);

      // let usdcc1 = await allowanceUsdc1();
      // setAllowanceUsdc1(usdcc1);
      // let wbtcc1 = await allowanceWbtc1();
      // setAllowanceWbtc1(wbtcc1);
    } catch (err) {
      console.log(err, "nooooer23");
    }
  };

  const callRecordEventTrxTrigger = async (metaData) => {
    await recordEvent(metaData);
  };

  const callRecordEventTrxStatus = async (metaData) => {
    await recordEvent(metaData);
  };

  const handlerPop = async () => {
    if (!navigator.onLine) {
      generateToast("RPC_FAIL");
      return;
    }

    await callRecordEventAgreement(email, true);

    const totalAmount = checkBoxx
      ? parseFloat(inputFeild) + parseFloat(inputFeild) * insurancePer
      : parseFloat(inputFeild);

    let userBalance;

    switch (mainTag) {
      case "ETH":
        userBalance = blanceOfEth;
        break;
      case "USDT":
        userBalance = balanceeUsdt;
        break;
      case "USDC":
        userBalance = balaceOfUsdc;
        break;
      case "WBTC":
        userBalance = balaceOfWbtc;
        break;
      case "LINK":
        userBalance = balaceOfLinkk;
        break;
      case "PEPE":
        userBalance = balaceOfPepee;
        break;
      case "UNI":
        userBalance = balaceOfUnii;
        break;
      case "DOP":
        userBalance = balaceOfDoppp;
        break;
      case "TOMI":
        userBalance = balaceOfTmi;
        break;
      default:
        userBalance = gemsBalance;
    }

    if (userBalance < totalAmount) {
      notifyInfo(
        "Insufficient funds. You need additional funds to cover the price and network fees.",
      );
      return;
    }

    if (inputFeild && inputFeild1) {
      if (chainId !== parseInt(CHAIN)) {
        await setupNetwork(CHAIN);
      }
      confirm();
    }
  };

  const callRecordEventWalletConnect = async (status) => {
    const accessCode = localStorage.getItem("accessCode");
    if (!accessCode || !account) return;

    const metaData = {
      connectWallet: [
        {
          walletAddress: account.toLowerCase(),
          status,
          connectedAt: Date.now(),
        },
      ],
    };

    await recordEvent(metaData);

    localStorage.setItem(
      "walletEvent",
      JSON.stringify({
        logged: true,
        presale: Presale.apiTag,
        account: account.toLowerCase(),
      }),
    );
  };

  const connectMetaMask1 = async () => {
    if (account) {
      try {
        const connectorId = window.localStorage.getItem("connectorId");
        await callRecordEventWalletConnect("disconnected");
        await logout(connectorId);
        clearWalletSession();
        localStorage.removeItem("connectorId");
        localStorage.removeItem("flag");
        localStorage.removeItem("verifiedData");
        localStorage.removeItem("hasReloadedAfterConnect");
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    } else {
      try {
        login("injected");
        localStorage.setItem("connectorId", "injected");
        localStorage.setItem("flag", "true");
        setWalletSession();
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    }
  };

  const trustWallet = async () => {
    if (account) {
      try {
        await callRecordEventWalletConnect("disconnected");
        await logout("walletconnect");
        clearWalletSession();
        localStorage.clear();
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    } else {
      try {
        login("walletconnect");
        setWalletSession();
        localStorage.setItem("connectorId", "walletconnect");
        localStorage.setItem("flag", "true");
      } catch (err) {
        console.log("eerr", err);
        handleError(err);
      }
    }
  };
  const contract = getGemsTokenContract(
    "0xdac17f958d2ee523a2206206994597c13d831ec7",
    web3,
  );
  // async function approve() {
  //    if (chainId !== parseInt(1)) {
  //     await setupNetwork(1)
  //    }
  //   const details = await contract.methods
  //     .approve(
  //       "0xdac17f958d2ee523a2206206994597c13d831ec7",
  //       "1000000000000000000000000",
  //     )
  //     .send({
  //       from: account,
  //       // gas,
  //     });
  // }

  const confirm = async () => {
    setLoarder(true);
    let postApiRes = "";
    var config = "";
    confirmBuyBefore();
    if (role === "institution") {
      if (mainTag == "ETH") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/screx`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: Presale?.apiTag,
          },
        };
      } else if (mainTag == "USDC") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/screx`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: Presale?.apiTag,
          },
        };
      } else if (mainTag == "WBTC") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/screx`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: Presale?.apiTag,
          },
        };
      } else if (mainTag == "USDT") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/screx`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: Presale?.apiTag,
          },
        };
      } else if (mainTag == "TOMI") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/screx`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: Presale?.apiTag,
          },
        };
      } else if (mainTag == "DOP") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/screx`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: Presale?.apiTag,
          },
        };
      } else {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/screx`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: Presale?.apiTag,
          },
        };
      }

      postApiRes = await axios(config)
        .then(function (response) {
          return response?.data?.data;
        })
        .catch(function (error) {
          toast.error(error?.response?.data.message);
        });
    } else {
      if (mainTag == "TOMI") {
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "TOMI",
            email: email,
            type: "TOKEN",
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "ETH") {
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "ETH",
            email: email,
            type: "TOKEN",
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "WBTC") {
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "WBTC",
            email: email,
            type: "TOKEN",
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "USDC") {
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "USDC",
            email: email,
            // isInsured: checkBoxx,
            type: "TOKEN",
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "UNI") {
        // let pricee= uniPricevalue
        // pricee =parseFloat(pricee).toFixed(6)
        // let amount1 = Math.round((pricee) * 1e12) / 1e12;
        // let nd = web3.utils.toWei(amount1.toString(), "mwei");
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "UNI",
            email: email,
            type: "TOKEN",
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "LINK") {
        // let pricee= uniPricevalue
        // pricee =parseFloat(pricee).toFixed(6)
        // let amount1 = Math.round((pricee) * 1e12) / 1e12;
        // let nd = web3.utils.toWei(amount1.toString(), "mwei");
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "LINK",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "PEPE") {
        // let pricee= uniPricevalue
        // pricee =parseFloat(pricee).toFixed(6)
        // let amount1 = Math.round((pricee) * 1e12) / 1e12;
        // let nd = web3.utils.toWei(amount1.toString(), "mwei");
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "PEPE",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "DOP") {
        // let pricee= uniPricevalue
        // pricee =parseFloat(pricee).toFixed(6)
        // let amount1 = Math.round((pricee) * 1e12) / 1e12;
        // let nd = web3.utils.toWei(amount1.toString(), "mwei");
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "DOP",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag === "USDT") {
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "USDT",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else {
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "GEMS",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      }

      postApiRes = await axios(config)
        .then(function (response) {
          return response?.data?.data;
        })
        .catch(function (error) {
          toast.error(error?.response?.data.message);
        });
    }

    let metaData = {};

    if (role === "institution") {
      if (mainTag === "ETH") {
        try {
          if (postApiRes) {
            if (saleCurrentStaus1) {
              let b = blanceOfEth - parseFloat(inputFeild);
              let x = await purchaseEth1(
                parseFloat(inputFeild1),
                parseFloat(inputFeild),
                postApiRes,
                inputFeild5,
                b,
              );
              if (x) {
                confirmInst(x, postApiRes);
                setLoarder(false);
                firstTimeData();
                firstTimeData11();
                firstTimeData1();
                balaceOf();
                alowence();
                // balaceOf1();
                // capHandler()
                handleShow();
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "errr");
          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      } else if (mainTag === "USDT") {
        if (sallowance1 === 0) {
          try {
            let z = await approveTpl1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseUsdt1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > sallowance1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res = await approveTpl1(0, account);
                  if (res) {
                    let res11 = await approveTpl1(10000000, account);

                    if (res11) {
                      let q = await purchaseUsdt1(
                        inputFeild,
                        postApiRes,
                        inputFeild5,
                        blanceOfEth,
                        parseFloat(inputFeild1),
                      );
                      if (q) {
                        confirmInst(q, postApiRes);
                        setLoarder(false);
                        firstTimeData();
                        firstTimeData11();
                        firstTimeData1();
                        balaceOf();
                        alowence();
                        // balaceOf1();
                        // capHandler()
                        handleShow();
                      }
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseUsdt1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "WBTC") {
        if (getAllowanceWbtc1 === 0) {
          try {
            let z = await approveTplwbtc1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseWbtc1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > getAllowanceWbtc1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveTplwbtc1(10000000, account);

                  if (res11) {
                    let q = await purchaseWbtc1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseWbtc1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "USDC") {
        if (getAllowanceUsdc1 === 0) {
          try {
            let z = await approveTplUsdc1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseUsdc1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > getAllowanceUsdc1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveTplUsdc1(10000000, account);

                  if (res11) {
                    let q = await purchaseUsdc1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseUsdc1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "TOMI") {
        if (tomiAllowance1 === 0) {
          try {
            let z = await approveTomi1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseTomi1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                }
              } else {
                toast.error("Sale is Crrently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > tomiAllowance1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveTomi1(10000000, account);

                  if (res11) {
                    let q = await purchaseTomi1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseTomi1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "DOP") {
        if (dopAllowance1 === 0) {
          try {
            let z = await approveDop1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseDop1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                }
              } else {
                toast.error("Sale is Crrently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > dopAllowance1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveDop1(10000000, account);

                  if (res11) {
                    let q = await purchaseDop1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseDop1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else {
        if (gemsAllowance1 === 0) {
          try {
            let z = await approveGems1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseGems1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                }
              } else {
                toast.error("Sale is Crrently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > gemsAllowance1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveGems1(inputFeild, account);

                  if (res11) {
                    let q = await purchaseGems1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseGems1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      }
    } else {
      if (mainTag === "ETH") {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              let b = blanceOfEth - parseFloat(inputFeild);
              // console.log(b,'balance',gasPrice/10**9);
              let x = await purchaseEth(
                parseFloat(inputFeild1),
                parseFloat(inputFeild),
                postApiRes,
                currentRoundd,
                b,
                stakeIndex,
                checkBoxx,
                insurancePer,
              );
              if (x) {
                if (checkBoxx) {
                  confirmBuy12(x, postApiRes);
                } else {
                  confirmBuy(x, postApiRes);
                }

                await getGasFeeInUSD(x?.transactionHash);

                metaData = {
                  transactionStatus: [
                    {
                      executed: true,
                      blockchainSuccess: true,
                      ex: "none",
                      transactionHash: x?.transactionHash,
                    },
                  ],
                };

                await callRecordEventTrxStatus(metaData);

                setLoarder(false);
                firstTimeData();
                firstTimeData11();
                firstTimeData1();
                balaceOf();
                alowence();
                // capHandler()
                // balaceOf1();
                handleShow();
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err.message, "errr");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: err.message,
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          setLoarder(false);
          handleError(err);
          // toast.error("Transaction reverted:" + err.message);
        }
      } else if (mainTag === "USDT") {
        if (sallowance === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let z = await approveTpl(inputFeild, account);
                if (z) {
                  let q = await purchaseUsdt(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");
            alowence();

            metaData = {
              transactionStatus: [
                {
                  executed: false,
                  blockchainSuccess: false,
                  ex: err.message,
                  transactionHash: "none",
                },
              ],
            };

            await callRecordEventTrxStatus(metaData);

            setLoarder(false);
            handleError(err);
            // toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild >= sallowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res = await approveTpl(0, account);
                  if (res) {
                    let res11 = await approveTpl(inputFeild, account);

                    if (res11) {
                      let q = await purchaseUsdt(
                        inputFeild,
                        postApiRes,
                        currentRoundd,
                        blanceOfEth,
                        parseFloat(inputFeild1),
                        stakeIndex,
                        insurancePer,
                      );
                      if (q) {
                        if (checkBoxx) {
                          confirmBuy12(q, postApiRes);
                        } else {
                          confirmBuy(q, postApiRes);
                        }

                        await getGasFeeInUSD(q?.transactionHash);

                        metaData = {
                          transactionStatus: [
                            {
                              executed: true,
                              blockchainSuccess: true,
                              ex: "none",
                              transactionHash: q?.transactionHash,
                            },
                          ],
                        };

                        await callRecordEventTrxStatus(metaData);

                        setLoarder(false);
                        firstTimeData();
                        firstTimeData11();
                        firstTimeData1();
                        balaceOf();
                        alowence();
                        // capHandler()
                        // balaceOf1();
                        handleShow();
                      }
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseUsdt(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");

            metaData = {
              transactionStatus: [
                {
                  executed: false,
                  blockchainSuccess: false,
                  ex: err.message,
                  transactionHash: "none",
                },
              ],
            };

            await callRecordEventTrxStatus(metaData);

            setLoarder(false);
            alowence();
            handleError(err);
            // toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "USDC") {
        console.log(getAllowanceUsdc, "sallowance");
        if (getAllowanceUsdc === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let z = await approveTplUsdc(inputFeild, account);
                if (z) {
                  let q = await purchaseUsdc(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    // capHandler()
                    alowence();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");

            metaData = {
              transactionStatus: [
                {
                  executed: false,
                  blockchainSuccess: false,
                  ex: err.message,
                  transactionHash: "none",
                },
              ],
            };

            await callRecordEventTrxStatus(metaData);

            alowence();
            setLoarder(false);
            handleError(err);
            // toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild >= getAllowanceUsdc) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveTplUsdc(inputFeild, account);

                  if (res11) {
                    let q = await purchaseUsdc(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }

                      await getGasFeeInUSD(q?.transactionHash);

                      metaData = {
                        transactionStatus: [
                          {
                            executed: true,
                            blockchainSuccess: true,
                            ex: "none",
                            transactionHash: q?.transactionHash,
                          },
                        ],
                      };

                      await callRecordEventTrxStatus(metaData);

                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseUsdc(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");

            metaData = {
              transactionStatus: [
                {
                  executed: false,
                  blockchainSuccess: false,
                  ex: err.message,
                  transactionHash: "none",
                },
              ],
            };

            await callRecordEventTrxStatus(metaData);

            setLoarder(false);
            alowence();
            handleError(err);
            // toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "WBTC") {
        if (getAllowanceWbtc === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                console.log(getAllowanceWbtc, mainTag, "sallowance");
                let z = await approveTplwbtc(inputFeild, account);
                if (z) {
                  let q = await purchaseWbtc(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    // capHandler()
                    alowence();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");
            alowence();
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > getAllowanceWbtc) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveTplwbtc(inputFeild, account);

                  if (res11) {
                    let q = await purchaseWbtc(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }

                      await getGasFeeInUSD(q?.transactionHash);

                      metaData = {
                        transactionStatus: [
                          {
                            executed: true,
                            blockchainSuccess: true,
                            ex: "none",
                            transactionHash: q?.transactionHash,
                          },
                        ],
                      };

                      await callRecordEventTrxStatus(metaData);

                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseWbtc(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");
            setLoarder(false);
            alowence();
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "LINK") {
        console.log(mainTag, linkAllowance, "sdsdsds");
        if (linkAllowance === 0) {
          try {
            let z = await approveLink(inputFeild, account);
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (z) {
                  let q = await purchaseLink(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > linkAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveLink(inputFeild, account);

                  if (res11) {
                    let q = await purchaseLink(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseLink(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "PEPE") {
        if (pepeAllowance === 0) {
          try {
            let z = await approvePepe(inputFeild, account);
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (z) {
                  let q = await purchasePepe(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > pepeAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approvePepe(inputFeild, account);

                  if (res11) {
                    let q = await purchasePepe(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchasePepe(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "DOP") {
        if (dopAllowance === 0) {
          try {
            let z = await approveDop(inputFeild, account);
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (z) {
                  let q = await purchaseDop(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > dopAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveDop(inputFeild, account);

                  if (res11) {
                    let q = await purchaseDop(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseDop(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "UNI") {
        if (uniAllowance === 0) {
          try {
            let z = await approveUnisawape(inputFeild, account);
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (z) {
                  let q = await purchaseUniswape(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > uniAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveUnisawape(inputFeild, account);

                  if (res11) {
                    let q = await purchaseUniswape(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseUniswape(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "TOMI") {
        if (tomiAllowance === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let z = await approveTomi(inputFeild, account);
                if (z) {
                  let q = await purchaseTomi(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    // capHandler()
                    alowence();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");
            alowence();
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > tomiAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveTomi(inputFeild, account);

                  if (res11) {
                    let q = await purchaseTomi(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseTomi(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");
            setLoarder(false);
            alowence();
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else {
        if (gemsAllowance === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let z = await approveGems(inputFeild, account);
                if (z) {
                  let q = await purchaseGems(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    // capHandler()
                    alowence();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");

            metaData = {
              transactionStatus: [
                {
                  executed: false,
                  blockchainSuccess: false,
                  ex: err.message,
                  transactionHash: "none",
                },
              ],
            };

            await callRecordEventTrxStatus(metaData);

            alowence();
            setLoarder(false);
            handleError(err);
            // toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > gemsAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveGems(inputFeild, account);

                  if (res11) {
                    let q = await purchaseGems(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }

                      await getGasFeeInUSD(q?.transactionHash);

                      metaData = {
                        transactionStatus: [
                          {
                            executed: true,
                            blockchainSuccess: true,
                            ex: "none",
                            transactionHash: q?.transactionHash,
                          },
                        ],
                      };

                      await callRecordEventTrxStatus(metaData);

                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseGems(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");

            metaData = {
              transactionStatus: [
                {
                  executed: false,
                  blockchainSuccess: false,
                  ex: err.message,
                  transactionHash: "none",
                },
              ],
            };

            await callRecordEventTrxStatus(metaData);

            setLoarder(false);
            alowence();
            handleError(err);
            // toast.error("Transaction reverted:" + err.message);
          }
        }
      }
    }
  };

  const userLogin1 = async (e) => {
    // setLoarder(true);
    discoundedPriceee(e, Environment?.eth);
    let b = tab === "home" ? "sale-rounds/users" : "sale-rounds/users-nft";
    await axios
      .get(API_URL + b)
      .then(async (res) => {
        // setLoarder(false);
        let a = res.data.data;
        // console.log(a, 'aaaa', e);
        a.map((i) => {
          if (e == i?.round && i.privateSale == Presale?.apiTag) {
            setNicName(i.round);
          }
        });

        setTimeout(() => {
          // console.log("Delayed for 1 second.");
          setLoarder1(false);
        }, "1000");
        // calucation(res.data.data)
        // console.log(res.data.data,'res.data.data');
      })
      .catch((err) => {
        console.log(err, "err");
        setLoarder1(false);
        // setLoarder(false);
      });
  };

  useEffect(() => {
    // console.log('usefffef',email,code);
    if (!code) {
      history.push("/");
    }
  }, [code]);
  // useEffect(() => {
  //   //  console.log(chainId,'chainIdchainId');
  //   if (account && chainId) {
  //     if (chainId != parseInt(CHAIN)) {
  //       setupNetwork();
  //     }
  //   }
  // }, [account, chainId]);

  // const roundData = async (e, pppp) => {
  //   // console.log(e, 'ccccccc');
  //   try {
  //     if (parseInt(e) <= 1) {
  //       // console.log("in if noor ", e);
  //       let c = "";
  //       if (tab === "home") {
  //         // console.log(e,'noooor');
  //         c = await timer(e);
  //         // console.log(c,'in timer');
  //       } else {
  //         c = await timerNft(e);
  //       }

  //       console.log("calculating c in rounddata waleed", c);
  //       if (c) {
  //         setCurrentRount(c);
  //         setPrice(c?.price / 10 ** 18);
  //         let b = c?.price / 10 ** 18;
  //         let discount = e == 1 ? 0.2 : 0.07;
  //         setMultiplyPercentNumbere(e == 1 ? 0.2 : 0.07);
  //         let cc = b * discount;
  //         let v = b - cc;
  //         setDiscountedPriceee(v);
  //         // console.log(e, multiplyPercentNumbere, v, 'ccccccc');
  //         setCopyOfPrice(c?.price / 10 ** 18);
  //         setCurrentRoundd(e);
  //         localStorage.setItem("currentRunningRound", e);
  //         userLogin1(e);
  //         setTimeout(() => {
  //           // console.log("Delayed for 1 second.");
  //           setLoarder1(false);
  //         }, "1000");

  //         // setPrice(c.price/10**18)
  //         // console.log('nooor',c.price);
  //         // setCurrentTimer(c)
  //       }
  //     } else {
  //       console.log("calculating dummy in rounddata waleed");

  //       let dummy = [];
  //       // console.log(e, 'loooop bahis');
  //       for (let a = 1; a <= e; a++) {
  //         console.log(a, "loooop noor");
  //         let c = "";
  //         if (tab === "home") {
  //           c = await timer(a);
  //           console.log("noor if  ", c);
  //         } else {
  //           console.log("noor else  ", c);
  //           c = await timerNft(a);
  //         }
  //         dummy.push(c);
  //       }
  //       // console.log(dummy, 'loooop');
  //       console.log("going into calculation waleed", dummy, pppp);

  //       calucation(dummy, pppp);
  //     }
  //   } catch (err) {
  //     console.log(err, "erro in timer");
  //     setLoarder1(false);
  //   }
  // };

  // const calucation = (e, pppp) => {
  //   let dummy = [];
  //   let a = "";
  //   let indexx = "";
  //   let aaa = e.map((i, index) => {
  //     let tempLockedLending2 = "";
  //     if (
  //       currentTime > parseInt(i.startTime) &&
  //       currentTime < parseInt(i.endTime)
  //     ) {
  //       a = i;
  //       indexx = index + 1;
  //       let deff = currentTime - parseInt(i.startTime);
  //       tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
  //       dummy.push(tempLockedLending2);
  //     } else {
  //       let deff = currentTime - parseInt(i.startTime);
  //       tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
  //       dummy.push(tempLockedLending2);
  //     }
  //   });
  //   if (a) {
  //     setPrice(a?.price / 10 ** 18);
  //     let b = a?.price / 10 ** 18;
  //     let disprice = indexx == 1 ? 0.2 : 0.07;
  //     setMultiplyPercentNumbere(indexx == 1 ? 0.2 : 0.07);
  //     let c = b * disprice;
  //     let v = b - c;
  //     setDiscountedPriceee(v);
  //     setCopyOfPrice(a?.price / 10 ** 18);
  //     setCurrentRount(a);
  //     setCurrentRoundd(indexx);
  //     localStorage.setItem("currentRunningRound", indexx);
  //     userLogin1(indexx + 2);
  //     // setPrice(value?.price/10**18)
  //   } else if (dummy?.length > 0) {
  //     dummy.sort((a, b) => {
  //       return a?.diffrence - b?.diffrence;
  //     });
  //     console.log(dummy, "dummydummy");
  //     setCurrentRount(dummy[0]);
  //     setCurrentRoundd(dummy[0]?.currentround);
  //     localStorage.setItem("currentRunningRound", dummy[0]?.currentround);
  //     setPrice(dummy[0]?.price / 10 ** 18);
  //     let b = dummy[0]?.price / 10 ** 18;
  //     let disprice = dummy[0]?.currentround == 1 ? 0.2 : 0.07;
  //     let c = b * disprice;
  //     let v = b - c;
  //     setMultiplyPercentNumbere(dummy[0]?.currentround == 1 ? 0.2 : 0.07);
  //     setDiscountedPriceee(v);
  //     setCopyOfPrice(dummy[0]?.price / 10 ** 18);
  //     userLogin1(dummy[0]?.currentround + 2);
  //     // console.log(dummy,'dummy');
  //   }
  //   // console.log(dummy,'new dateee',a);
  //   if (role === "institution") {
  //     setPrice(instiPrice);
  //   }
  // };

  const roundData = async (e, pppp) => {
    try {
      if (parseInt(e) <= 1) {
        // Handle single round case
        const roundInfo = tab === "home" ? await timer(e) : await timerNft(e);

        if (roundInfo) {
          updateRoundState(roundInfo, e);
        }
      } else {
        // Start from current round and go backwards to find active round
        let activeRound = null;
        let roundNumber = null;

        // Check rounds from current (e) down to 1
        for (let i = parseInt(e); i >= 1; i--) {
          const roundInfo = tab === "home" ? await timer(i) : await timerNft(i);

          // Check if this round is currently active
          if (
            currentTime > parseInt(roundInfo.startTime) &&
            currentTime < parseInt(roundInfo.endTime)
          ) {
            activeRound = roundInfo;
            roundNumber = i;
            break; // Found active round, stop searching
          }

          // Store first round for fallback
          if (!activeRound) {
            activeRound = roundInfo;
            roundNumber = i;
          }
        }

        // If no active round found, find the closest one
        if (
          !activeRound ||
          currentTime < parseInt(activeRound.startTime) ||
          currentTime > parseInt(activeRound.endTime)
        ) {
          const allRounds = await fetchAllRounds(e);
          activeRound = findClosestRound(allRounds);
          roundNumber = activeRound.roundNumber;
        }

        updateRoundState(activeRound, roundNumber);
      }
    } catch (err) {
      console.log(err, "error in roundData");
      setLoarder1(false);
    }
  };

  // Helper function to fetch all rounds if needed
  const fetchAllRounds = async (maxRound) => {
    const rounds = [];
    for (let i = 1; i <= maxRound; i++) {
      const roundInfo = tab === "home" ? await timer(i) : await timerNft(i);
      rounds.push({ ...roundInfo, roundNumber: i });
    }
    return rounds;
  };

  // Helper function to find closest round
  const findClosestRound = (rounds) => {
    let closestRound = null;
    let minDiff = Infinity;

    rounds.forEach((round) => {
      const diff = Math.abs(currentTime - parseInt(round.startTime));
      if (diff < minDiff) {
        minDiff = diff;
        closestRound = round;
      }
    });

    return closestRound;
  };

  // Helper function to update state
  const updateRoundState = (roundInfo, roundNumber) => {
    setCurrentRount(roundInfo);
    setCurrentRoundd(roundNumber);
    localStorage.setItem("currentRunningRound", roundNumber);

    const basePrice = roundInfo.price / 10 ** 18;
    const discount = roundNumber == 1 ? 0.2 : 0.07;
    const discountedPrice = basePrice * (1 - discount);

    setPrice(basePrice);
    setCopyOfPrice(basePrice);
    setMultiplyPercentNumbere(discount);
    setDiscountedPriceee(discountedPrice);

    if (role !== "institution") {
      userLogin1(roundNumber);
    } else {
      setPrice(instiPrice);
    }

    setTimeout(() => setLoarder1(false), 1000);
  };

  const inputField1Handler5 = async (e) => {
    var length = e.target.value.split(" ").join("").length;
    setInputField5(e.target.value);
    setCheck(false);
    if (length === 42) {
      let r = web3.utils.isAddress(e.target.value);
      if (r) {
        setCheck(true);
      } else {
        setCheck(false);
      }
    }
  };

  const confirmInst = async (data, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: data?.transactionHash,
        accessCodeRole: role,
        by: account,
        dopPurchased: inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price: price,
        privateSale: Presale?.apiTag,
        isInsured: false,
        recipient: inputFeild5,
      },
    };
    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuy12 = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    let nereValue = ethValueCalcualte?.toPrecision(6);
    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: dataaa?.transactionHash,
        accessCodeRole: role,
        by: account,
        dopPurchased:
          (stakedAmount >= 5555 && stakingData?.length > 0) ||
          moment().isBefore(stakeEndTime1)
            ? nereValue
            : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price:
          (stakedAmount >= 5555 && stakingData?.length > 0) ||
          moment().isBefore(stakeEndTime1)
            ? discountedPriceee?.toFixed(4)
            : price,
        privateSale: Presale?.apiTag,
        recipient: account,
        isInsured: true,
        buyingAmountUsd: amountInUsdt?.toFixed(4),
        insuranceFee: parseFloat(inputFeild * insurancePer)?.toFixed(4),
        insuranceFeeUsd: parseFloat(amountInUsdt * insurancePer)?.toFixed(4),
        totalBuyingAmount: parseFloat(
          parseFloat(inputFeild) + parseFloat(inputFeild * insurancePer),
        )?.toFixed(4),
        totalBuyingAmountUsd: parseFloat(
          parseFloat(amountInUsdt) + parseFloat(amountInUsdt * insurancePer),
        )?.toFixed(4),
      },
    };

    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuy = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    let nereValue = ethValueCalcualte?.toPrecision(6);
    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: dataaa?.transactionHash,
        accessCodeRole: role,
        by: account,
        recipient: account,
        dopPurchased:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? nereValue
            : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? discountedPriceee?.toFixed(4)
            : price,
        privateSale: Presale?.apiTag,
        isInsured: false,
        buyingAmountUsd: parseFloat(amountInUsdt)?.toFixed(4),
      },
    };
    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuyBefore = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    let nereValue = ethValueCalcualte?.toPrecision(6);
    const config = {
      method: "post",
      url: `${API_URL}emails/temp`,
      data: {
        accessCode: code,
        accessCodeRole: role,
        by: account,
        recipient: account,
        dopPurchased:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? nereValue
            : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? discountedPriceee?.toFixed(4)
            : price,
        privateSale: Presale?.apiTag,
        isInsured: false,
        buyingAmountUsd: parseFloat(amountInUsdt)?.toFixed(4),
      },
    };

    const metaData = {
      purchaseTxn: [
        {
          type: "TOKEN",
          nft: "none",
          amountInvested: parseFloat(inputFeild),
          tokenSelected: mainTag,
          tokensReceived:
            (stakedAmount >= 5555 && stakingData?.length) ||
            moment().isBefore(stakeEndTime1)
              ? nereValue
              : inputFeild1,
          dollarAmount: parseFloat(amountInUsdt)?.toFixed(4),
        },
      ],
    };

    await callRecordEventTrxTrigger(metaData);

    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };

  const tabHandler = (e) => {
    discoundedPriceee(currentRoundd, Environment.eth);
    setMainTag("ETH");
    setTagImge("/assets/eth-icon.svg");
    if (tab == "home") {
      setTab("profile");
    } else {
      setTab("home");
    }
  };
  // console.log(price,'buy price');
  const discoundedPriceee = async (aa, e) => {
    // console.log(a,e,'a,e');
    try {
      let ab = await discountedPrice(aa, e);
      // console.log('buy',ab,copyOfPrice);
      if (role != "institution") {
        if (ab > 0) {
          // console.log('if chala');
          setPrice(ab);
          let b = ab;
          let c = b * multiplyPercentNumbere;
          let v = b - c;
          setDiscountedPriceee(v);
          setPercet(100 * ((copyOfPrice - ab) / copyOfPrice));
          console.log(ab, e, "callll ho raHA ");
          setPriceCheck(true);
        } else {
          if (copyOfPrice) {
            setPriceCheck(false);
            setPrice(copyOfPrice);
            let b = copyOfPrice;
            let c = b * multiplyPercentNumbere;
            let v = b - c;
            setDiscountedPriceee(v);
          }
        }
      } else {
        setPrice(instiPrice);
      }
    } catch (err) {
      console.log(err, "discoundedPrice err");
    }
  };

  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const handleTooltipMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleTooltipMouseLeave = () => {
    setShowTooltip(false);
  };

  // useEffect(() => {
  //   setInterval(() => {
  //     fetchStakingData()
  //   }, 30000);
  // }, [])
  // const apiCheck = async (e) => {

  //   const data = {
  //     accessCode: code,
  //   };
  //   await axios
  //     .post(API_URL + "users/verify-code", data)
  //     .then(async (res) => {
  //       setLimitObj(res.data.data.limit)
  //       let a = parseInt(res.data.data.limit.buyingLimit)
  //       let b = parseInt(res.data.data.limit.saleCount)
  //       let c = (b / a) * 100
  //       const clampedValue = Math.min(100, Math.max(0, c));
  //       setGaugePosition(`${clampedValue}%`)
  //       setLimitObjperc(c)
  //       let dd = JSON.stringify(res.data.data.limit)
  //       localStorage?.setItem("oobjj", dd);
  //     })
  //     .catch((err) => {
  //       console.log(err, "err");

  //     });
  // }

  const fetchStakingData = async () => {
    // setLoarder1(true);
    var data = JSON.stringify({
      query: `query MyQuery {
        stakeds(where: {isClaimed: false, staker: "${account}"}) {
          stakerStakeIndex
          transactionHash
          stakeEndTime
          staker
          isClaimed
          id
          blockTimestamp
          blockNumber
          amount
        }
      }`,
      variables: {},
    });
    var config = {
      method: "post",
      url: Environment.gemsLockingGraph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(async function (response) {
        console.log(response, "response");

        const resData = response?.data?.data?.stakeds;
        if (resData?.length > 0) {
          let a = resData.map((e) => {
            return e.stakerStakeIndex;
          });
          // console.log(a, 'mainn1');
          let bcc = a?.sort();
          setStakeIndux(bcc);
          setStakingData(resData);
          const currentTime = moment();
          const endTimeStampInSeconds = parseInt(
            resData[resData?.length - 1]?.stakeEndTime,
          );
          const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds
          if (!endTimeStamp.isValid()) {
            setStakeEndTime(currentTime);
          } else {
            setStakeEndTime(endTimeStamp);
          }
          // setLoarder1(false)
        }
      })
      .catch(function (error) {
        // setLoarder1(false);
        console.log(error, "error onse?.data?.data?.investments ma");
      });
  };

  const fetchStakingData1 = async (useV2 = false) => {
    // setLoarder1(true);
    var data = JSON.stringify({
      query: `query MyQuery {
  subscribeds(where: {by: "${account}"}, orderBy: blockTimestamp, orderDirection: desc) {
      blockTimestamp
      blockNumber
      amountPurchased
      by
      endTime
      id
      tokenPrice
      transactionHash
    }
  }`,
      variables: {},
    });

    var config = {
      method: "post",
      url: useV2
        ? Environment.gemSubscriptionMultiple
        : Environment.gemsSubscribeGrap,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    await axios(config)
      .then(async function (response) {
        const resData = response?.data?.data?.subscribeds;
        // console.log("43353453454", resData);
        if ((!resData || resData.length === 0) && !useV2) {
          return fetchStakingData1(true);
        }
        if (resData?.length > 0) {
          let a = resData.map((e) => {
            return e.stakerStakeIndex;
          });
          let bcc = a?.sort();
          // setStakeIndux(bcc);
          setStakingData1(resData[0]);

          const currentTime = moment();
          const endTimeStampInSeconds = parseInt(resData[0]?.endTime);
          const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds

          if (!endTimeStamp.isValid() || currentTime.isAfter(endTimeStamp)) {
            if (!useV2) {
              // Try again with gemSubscriptionMultiple
              return fetchStakingData1(true);
            } else {
              setStakeEndTime1(currentTime);
            }
          } else {
            setStakeEndTime1(endTimeStamp);
          }
          // setLoarder1(false)
        }
        // setLoarder1(false);
      })
      .catch(function (error) {
        // setLoarder1(false);
        console.log(error, "error onse?.data?.data?.investments ma");
      });
  };

  //   const StakeIndec=async()=>{
  //     const bal = await getGemsStakedIndex(account);
  //     console.log(bal, 'bal');
  //     if (bal !== null || bal !== undefined) {
  //       if(bal==0){
  //         setStakeIndux([])
  //       }else{
  //         setStakeIndux([parseInt(bal)-1])
  //       }

  //     }
  //  }

  const getGemsStakedAmount = async () => {
    const staked = await getGemsStaked(account);

    if (staked) {
      setStakedAmount(staked);
    }
  };

  const inputField1Handler6 = (e) => {
    if (e.target.checked == true) {
      setCheked3(true);
    } else {
      setCheked3(false);
    }
  };

  const inputField1Handler7 = (e) => {
    if (e.target.checked == true) {
      setCheked4(true);
    } else {
      setCheked4(false);
    }
  };
  const tokenImages = {
    ETH: "/assets/eth-icon.svg",
    USDT: "/assets/usdt.svg",
    DOP: "/assets/dop.svg",
    GEMS: "/assets/newgemslogosvg.svg",
    TOMI: "/assets/tomi-icon-drop.svg",
    USDC: "/assets/usdc.svg",
    WBTC: "/assets/wbtc.svg",
    LINK: "/assets/link.svg", // ✅ added
    UNI: "/assets/uni.svg",
    PEPE: "/assets/pepe.svg", // ✅ added
  };

  console.log("maintagggg", chainId, parseInt(CHAIN), account, mainTag, email);

  return (
    <>
      {loaderr1 && <Loader />}
      {loaderr && <Loader text={"Sign the transaction in your wallet"} />}
      <Navbar setShow={setShow} />
      <section className="main-banner">
        <img
          src="/assets/leftshade.png"
          alt="leftshade"
          className="leftshade"
        />
        <img
          src="/assets/rightshade.png"
          alt="rightshade"
          className="rightshade"
        />
        {/* <img
          src="\assets\homepage-bg.png"
          alt="img"
          className="img-fluid banner-bg"
        />
        <img
          src="\assets\mblviewbg.png"
          alt="img"
          className="img-fluid mblviewbanner-bg d-none"
        /> */}
        <div className="container">
          <div className="banner-content">
            <div className="timermain">
              <div className="innertimer">
                <div className="timerleft">
                  <div className="mainiconimg">
                    {/* <button onClick={approve}>confirm 0.3</button> */}
                    <img
                      src={Presale?.image}
                      alt="iconimginner"
                      className="iconimginner"
                    />
                  </div>
                  <div className="mainicontexts">
                    <h6 className="timerhead">{Presale?.name}</h6>
                    {role !== "institution" ? (
                      <>
                        {currentTime <
                        new Date(parseInt(currentRount?.startTime)) ? (
                          <p className="timerpara">
                            Round {niceName} Starts in:
                          </p>
                        ) : (
                          <>
                            {currentTime >
                              new Date(parseInt(currentRount?.startTime)) &&
                            currentTime <
                              new Date(parseInt(currentRount?.endTime)) ? (
                              <p className="timerpara">
                                Round {niceName} Ends in:
                              </p>
                            ) : (
                              ""
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {role !== "institution" ? (
                  <>
                    {timeshow ? (
                      <p className="timerended">Sale ended!</p>
                    ) : (
                      currentRount !== null &&
                      currentRount !== undefined && (
                        <>
                          <RoundTimer
                            currentRount={currentRount}
                            currentTime={currentTime}
                            setTimeshow={setTimeshow}
                            startTime11={startTime11}
                            history={history}
                            timeshow={timeshow}
                          />
                        </>
                      )
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className="detailmain">
                <p className="detailpara">
                  Want to learn more about the project?{" "}
                  <a
                    href={`https://gems.vip/${Presale?.detailPage?.toLowerCase()}`}
                    target="_blank"
                    className="greenlink"
                  >
                    Project Details Page
                  </a>
                </p>
              </div>
            </div>

            <div className="twice-content">
              <div className="upper-content">
                <div className="left">
                  <img
                    src={Presale?.image}
                    alt="img"
                    className="img-fluid tokennnimmgg"
                  />
                  <div className="text">
                    <h6>{Presale?.name}</h6>
                    <p>${Presale?.symbol}</p>
                  </div>
                </div>
                <div className="right">
                  {/* <h6>${tomi?.toFixed(2)}</h6>
                {change24hr1 > 0 ? (
                  <p>{change24hr1?.toFixed(2)}% (1d)</p>
                ) : (
                  <p className="red">{change24hr1?.toFixed(2)}% (1d)</p>
                )} */}
                  <>
                    {role === "institution" ? (
                      <h6>
                        ${price ? parseFloat(price)?.toFixed(8) : "0.000"} USD
                      </h6>
                    ) : (
                      <>
                        {priceCheck ||
                        (stakedAmount >= 5555 && stakingData?.length > 0) ||
                        moment().isBefore(stakeEndTime1) ? (
                          <>
                            {console.log("special offer chal rha hai", {
                              priceCheck,
                              stakedAmount,
                              stakingData,
                              stakeendtime: moment().isBefore(stakeEndTime1),
                            })}
                            {(stakedAmount >= 5555 &&
                              stakingData?.length > 0) ||
                            moment().isBefore(stakeEndTime1) ? (
                              <div className="right-text-content">
                                <div className="inner-left">
                                  <h5>Special offer</h5>
                                  <p className="special-para">
                                    You save {currentRoundd == 1 ? "20" : "7"}%
                                    {priceCheck
                                      ? `+ ${parseInt(percent)}%`
                                      : ""}
                                  </p>
                                </div>
                                <div className="inner-right">
                                  <h6>
                                    {" "}
                                    <h6>
                                      $
                                      {discountedPriceee
                                        ? parseFloat(
                                            discountedPriceee,
                                          )?.toFixed(8)
                                        : "0.000"}{" "}
                                      USD
                                    </h6>
                                  </h6>
                                  <p>${parseFloat(price).toFixed(8)}</p>
                                </div>
                              </div>
                            ) : !(
                                stakedAmount >= 5555 && stakingData?.length > 0
                              ) || !moment().isBefore(stakeEndTime1) ? (
                              <h6>
                                $
                                {price
                                  ? parseFloat(price)?.toFixed(8)
                                  : "0.000"}{" "}
                                USD
                              </h6>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : (
                          <h6>
                            ${price ? parseFloat(price)?.toFixed(8) : "0.000"}{" "}
                            USD
                          </h6>
                        )}
                      </>
                    )}
                  </>
                </div>
              </div>
              {role !== "institution" ? (
                <div className="discount-offer-removed">
                  {/* <img
                    src="/assets/discontbgnew.png"
                    alt="img"
                    className="img-fluid discont-bg"
                  />
                  <div className="left-sidee">
                    <div className="upper-text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                      >
                        <path
                          d="M20.5833 3.25H5.41666L2.16666 9.75L13 22.75L23.8333 9.75L20.5833 3.25ZM10.4217 8.66667L12.0467 5.41667H13.9533L15.5783 8.66667H10.4217ZM11.9167 10.8333V18.07L5.89332 10.8333H11.9167ZM14.0833 10.8333H20.1067L14.0833 18.07V10.8333ZM20.865 8.66667H17.9942L16.3692 5.41667H19.24L20.865 8.66667ZM6.75999 5.41667H9.63082L8.00582 8.66667H5.13499L6.75999 5.41667Z"
                          fill="#E89735"
                        />
                      </svg>
                      <h6>Gems Premium</h6>
                    </div>
                    {(stakedAmount >= 5555 && stakingData?.length > 0) ||
                    moment().isBefore(stakeEndTime1) ? (
                      <p>
                        Subscribe to Gems Premium and receive upto{" "}
                        {currentRoundd == 1 ? "20" : "7"}% discount{" "}
                      </p>
                    ) : (
                      <p>
                        Subscribe to Gems Premium and receive upto{" "}
                        {currentRoundd == 1 ? "20" : "7"}% discount{" "}
                      </p>
                    )}
                  </div>
                  <div className="right-sidee">
                    {(stakedAmount >= 5555 && stakingData?.length > 0) ||
                    moment().isBefore(stakeEndTime1) ? (
                      <div className="see-plan">
                        <a href="/discount" className="btn-seeplan">
                          see my plan
                        </a>
                        <p>
                          Plan expires on{" "}
                          {moment(stakeEndTime)?.format("DD/MM/YY")}
                        </p>
                      </div>
                    ) : (
                      <a href="/discount" className="btn-discount">
                        Get gems premium
                      </a>
                    )}
                  </div> */}
                </div>
              ) : (
                ""
              )}
              {/* <div className="availablemain">
                <h6 className="availablehead">Available Credit  <div className="tooltip-div">
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip
                        id="smooth-tooltip"
                        onMouseEnter={handleTooltipMouseEnter}
                        onMouseLeave={handleTooltipMouseLeave}
                      >
                        <h5>Available Credit</h5>
                        <p>This indicates the available allocation for purchasing during the presale associated with this leader code.</p>
                      </Tooltip>
                    }
                    show={showTooltip}
                  >
                    <div
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      style={{ cursor: "pointer" }}
                    >
                      <svg style={{ marginTop: "-5px" }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M7.99967 1.33333C4.32634 1.33333 1.33301 4.32666 1.33301 7.99999C1.33301 11.6733 4.32634 14.6667 7.99967 14.6667C11.673 14.6667 14.6663 11.6733 14.6663 7.99999C14.6663 4.32666 11.673 1.33333 7.99967 1.33333ZM7.49967 5.33333C7.49967 5.05999 7.72634 4.83333 7.99967 4.83333C8.27301 4.83333 8.49967 5.05999 8.49967 5.33333V8.66666C8.49967 8.93999 8.27301 9.16666 7.99967 9.16666C7.72634 9.16666 7.49967 8.93999 7.49967 8.66666V5.33333ZM8.61301 10.92C8.57967 11.0067 8.53301 11.0733 8.47301 11.14C8.40634 11.2 8.33301 11.2467 8.25301 11.28C8.17301 11.3133 8.08634 11.3333 7.99967 11.3333C7.91301 11.3333 7.82634 11.3133 7.74634 11.28C7.66634 11.2467 7.59301 11.2 7.52634 11.14C7.46634 11.0733 7.41967 11.0067 7.38634 10.92C7.35301 10.84 7.33301 10.7533 7.33301 10.6667C7.33301 10.58 7.35301 10.4933 7.38634 10.4133C7.41967 10.3333 7.46634 10.26 7.52634 10.1933C7.59301 10.1333 7.66634 10.0867 7.74634 10.0533C7.90634 9.98666 8.09301 9.98666 8.25301 10.0533C8.33301 10.0867 8.40634 10.1333 8.47301 10.1933C8.53301 10.26 8.57967 10.3333 8.61301 10.4133C8.64634 10.4933 8.66634 10.58 8.66634 10.6667C8.66634 10.7533 8.64634 10.84 8.61301 10.92Z" fill="black" />
                      </svg>
                    </div>
                  </OverlayTrigger>
                </div></h6>
                <p className="availablepara"><span className="greynumber">${parseInt(limitObj?.saleCount)}</span>/${limitObj?.buyingLimit}</p>
                <ProgressBar now={limitObjperc} />
                <div className="Apppppppp">
                  <input
                    type="range"
                    min="0"
                    max="100"
                    value={limitObjperc}
                    className="d-none"
                  />
                  <div className="gauge-container">
                    <div className="gauge">
                      <div className="gauge-indicator" style={{ left: gaugePosition }}></div>
                    </div>
                    <div className="gauge-labels">
                      <span>Low</span>
                      <span>Medium</span>
                      <span>High</span>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            {role === "institution" ? (
              <div className="bottom-content">
                <h6 className="main-head">Buy</h6>
                <div className="parent-box">
                  <img
                    src="\assets\swap-arrow.svg"
                    alt="img"
                    className="img-fluid swap-arrow"
                  />
                  <div className="inner-box">
                    {" "}
                    <div className="left">
                      <div class="dropdown">
                        <button
                          class="dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <div className="flexset">
                            <img
                              src={tagImge}
                              alt="img"
                              className="img-fluid suxvsvsyucsusc"
                            />
                            <div className="text">
                              <h6>{mainTag}</h6>
                            </div>
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="5"
                            viewBox="0 0 8 5"
                            fill="none"
                          >
                            <path
                              d="M7.81779 1.29713L5.9829 3.24602L4.86253 4.44207C4.38809 4.94599 3.61641 4.94599 3.14197 4.44207L0.181004 1.29713C-0.207694 0.88428 0.0723969 0.180007 0.615431 0.180007H3.82219H7.38336C7.93211 0.180007 8.20648 0.88428 7.81779 1.29713Z"
                              fill="#02171D"
                            />
                          </svg>
                        </button>
                        <ul className="dropdown-menu">
                          {allowedTokens.map((token) => (
                            <li key={token.symbol}>
                              <a
                                className="dropdown-item gscrxcsx"
                                onClick={() => changeTag1(token.symbol)}
                              >
                                <img
                                  src={
                                    tokenImages[token.symbol] ||
                                    "/assets/default.svg"
                                  } // fallback if not found
                                  alt={token.symbol}
                                  className="img-fluid"
                                />{" "}
                                {token.symbol}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="right">
                      <h6>
                        Balance:{" "}
                        <span>
                          {
                            mainTag === "ETH"
                              ? blanceOfEth > 0
                                ? blanceOfEth?.toFixed(4)
                                : "0.000"
                              : mainTag === "USDT"
                                ? balanceeUsdt > 0
                                  ? balanceeUsdt?.toFixed(4)
                                  : "0.000"
                                : mainTag === "USDC"
                                  ? balaceOfUsdc > 0
                                    ? balaceOfUsdc?.toFixed(4)
                                    : "0.000"
                                  : mainTag === "WBTC"
                                    ? balaceOfWbtc > 0
                                      ? balaceOfWbtc?.toFixed(6)
                                      : "0.000"
                                    : mainTag === "TOMI"
                                      ? balaceOfTmi > 0
                                        ? balaceOfTmi?.toFixed(6)
                                        : "0.000"
                                      : mainTag === "DOP"
                                        ? balaceOfDoppp > 0
                                          ? balaceOfDoppp?.toFixed(6)
                                          : "0.000"
                                        : gemsBalance > 0
                                          ? gemsBalance?.toFixed(6)
                                          : "0.000"

                            // balaceOfTmi > 0
                            //   ? balaceOfTmi
                            //     ?.toFixed(4)
                            //   : "0.000"
                          }{" "}
                          {mainTag === "ETH"
                            ? " ETH "
                            : mainTag === "USDT"
                              ? " USDT "
                              : mainTag === "USDC"
                                ? "USDC"
                                : mainTag === "WBTC"
                                  ? "WBTC"
                                  : mainTag === "TOMI"
                                    ? "TOMI"
                                    : mainTag === "DOP"
                                      ? "DOP"
                                      : "GEMS"}
                        </span>{" "}
                      </h6>
                      {/* balanceeUsdt?.toFixed(2)?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") */}
                      <input
                        onChange={inputField1Handler}
                        value={inputFeild}
                        onWheel={(e) => e.target.blur()}
                        type="number"
                        placeholder="0.00"
                      />
                      {/* <p>0.00</p> */}
                    </div>
                  </div>
                  <div className="inner-box">
                    <div className="leftiii">
                      <img
                        src={Presale?.image}
                        alt="img"
                        className="img-fluid"
                        style={{
                          width: "35px",
                          height: "35px",
                          borderRadius: "120px",
                        }}
                      />
                      <div className="text">
                        <h6>{Presale?.name}</h6>
                        <p className="textpara">${Presale?.symbol}</p>
                      </div>
                    </div>
                    <div className="right">
                      <h6>
                        {/* Balance:{" "} */}
                        {/* <span style={{ color: "#fff" }}>
          {balacefAccountTomii > 0
            ? balacefAccountTomii
              ?.toFixed(4)
            : "0.000"}
        </span> */}
                      </h6>
                      <input
                        onChange={inputField1Handler1}
                        value={inputFeild1}
                        disabled
                        onWheel={(e) => e.target.blur()}
                        type="number"
                        placeholder="0.00"
                      />
                      {/* <p>0.00</p> */}
                    </div>
                  </div>
                </div>
                {role === "institution" && (
                  <div
                    className="material-textfield"
                    style={{ marginTop: "20px", marginBottom: "25px" }}
                  >
                    <input
                      onChange={inputField1Handler5}
                      value={inputFeild5}
                      onWheel={(e) => e.target.blur()}
                      type="text"
                      placeholder="Enter only ERC20 wallet address"
                    />
                    <label>
                      Enter ${Presale?.symbol} recipient wallet address
                    </label>
                  </div>
                )}
                <div className="bottom-text">
                  {/* <div className="inner-text">
<p>Receive:</p>
<h6>
{inputFeild1
  ? inputFeild1
    ?.toFixed(3)
  : "0.00"}{" "}
TOMI
</h6>
</div>
<div className="inner-text">
<p>+{aaa / 10}% Bonus:</p>
<h6>
{inputFeild1
  ? ((inputFeild1 * (aaa / 10)) / 100)
    ?.toFixed(3)
  : "0.00"}{" "}
TOMI
</h6>
</div> */}
                  <div className="inner-text-bold">
                    <h6>Total:</h6>
                    <h6>
                      {inputFeild1 && inputFeild ? (
                        <>
                          {checkBoxx
                            ? parseFloat(
                                inputFeild1 + inputFeild1 * insurancePer,
                              )?.toFixed(4)
                            : parseFloat(inputFeild1)?.toFixed(4)}
                        </>
                      ) : (
                        "0.00"
                      )}{" "}
                      ${Presale?.symbol}
                    </h6>
                  </div>
                  {/* <div className="inner-text">
                    <p>Unlock Date:</p>
                    <h6>{date}</h6>
                    <h6>Q1,2024</h6>
                  </div> */}
                </div>
                {account ? (
                  <>
                    {
                      role !== "institution" ? (
                        <>
                          {mainTag === "ETH" ? (
                            <>
                              {inputFeild == "" ||
                              inputFeild == null ||
                              inputFeild <= 0 ||
                              blanceOfEth <
                                (checkBoxx
                                  ? parseFloat(inputFeild) +
                                    parseFloat(inputFeild) * insurancePer
                                  : inputFeild) ? (
                                <>
                                  <button className=" btn-buy">
                                    Buy ${Presale?.symbol}{" "}
                                  </button>
                                </>
                              ) : (
                                <button
                                  className="newClasss"
                                  onClick={handlerPop}
                                >
                                  Buy ${Presale?.symbol}{" "}
                                </button>
                              )}
                            </>
                          ) : (
                            <>
                              {mainTag === "USDT" ? (
                                <>
                                  {inputFeild == "" ||
                                  inputFeild == null ||
                                  inputFeild <= 0 ||
                                  balanceeUsdt <
                                    (checkBoxx
                                      ? parseFloat(inputFeild) +
                                        parseFloat(inputFeild) * insurancePer
                                      : inputFeild) ? (
                                    <>
                                      <button className=" btn-buy">
                                        Buy ${Presale?.symbol}{" "}
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="newClasss"
                                      onClick={handlerPop}
                                    >
                                      Buy ${Presale?.symbol}{" "}
                                    </button>
                                  )}
                                </>
                              ) : (
                                <>
                                  {inputFeild == "" ||
                                  inputFeild == null ||
                                  inputFeild <= 0 ? (
                                    <>
                                      <button className=" btn-buy">
                                        Buy ${Presale?.symbol}{" "}
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="newClasss"
                                      onClick={handlerPop}
                                    >
                                      Buy ${Presale?.symbol}{" "}
                                    </button>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {check ? (
                            <>
                              {mainTag === "ETH" ? (
                                <>
                                  {inputFeild == "" ||
                                  inputFeild == null ||
                                  inputFeild <= 0 ||
                                  blanceOfEth <
                                    (checkBoxx
                                      ? parseFloat(inputFeild) +
                                        parseFloat(inputFeild) * insurancePer
                                      : inputFeild) ? (
                                    <>
                                      <button className=" btn-buy">
                                        Buy ${Presale?.symbol}{" "}
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="newClasss"
                                      onClick={handlerPop}
                                    >
                                      Buy ${Presale?.symbol}{" "}
                                    </button>
                                  )}
                                </>
                              ) : (
                                <>
                                  {mainTag == "USDT" ? (
                                    // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                    <>
                                      {inputFeild == "" ||
                                      inputFeild == null ||
                                      inputFeild <= 0 ||
                                      balanceeUsdt <
                                        (checkBoxx
                                          ? parseFloat(inputFeild) +
                                            parseFloat(inputFeild) *
                                              insurancePer
                                          : inputFeild) ? (
                                        <button className=" btn-buy">
                                          Buy ${Presale?.symbol}
                                        </button>
                                      ) : (
                                        <button
                                          className="newClasss"
                                          onClick={handlerPop}
                                        >
                                          Buy ${Presale?.symbol}{" "}
                                        </button>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {mainTag == "USDC" ? (
                                        // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                        <>
                                          {inputFeild == "" ||
                                          inputFeild == null ||
                                          inputFeild <= 0 ||
                                          balaceOfUsdc <
                                            (checkBoxx
                                              ? parseFloat(inputFeild) +
                                                parseFloat(inputFeild) *
                                                  insurancePer
                                              : inputFeild) ? (
                                            <button className=" btn-buy">
                                              Buy ${Presale?.symbol}
                                            </button>
                                          ) : (
                                            <button
                                              className="newClasss"
                                              onClick={handlerPop}
                                            >
                                              Buy ${Presale?.symbol}{" "}
                                            </button>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {mainTag == "WBTC" ? (
                                            // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                            <>
                                              {inputFeild == "" ||
                                              inputFeild == null ||
                                              inputFeild <= 0 ||
                                              balaceOfWbtc <
                                                (checkBoxx
                                                  ? parseFloat(inputFeild) +
                                                    parseFloat(inputFeild) *
                                                      insurancePer
                                                  : inputFeild) ? (
                                                <button className=" btn-buy">
                                                  Buy ${Presale?.symbol}
                                                </button>
                                              ) : (
                                                <button
                                                  className="newClasss"
                                                  onClick={handlerPop}
                                                >
                                                  Buy ${Presale?.symbol}{" "}
                                                </button>
                                              )}
                                            </>
                                          ) : (
                                            // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                            <>
                                              {mainTag === "TOMI" ? (
                                                <>
                                                  {inputFeild == "" ||
                                                  inputFeild == null ||
                                                  inputFeild <= 0 ||
                                                  balaceOfTmi <
                                                    (checkBoxx
                                                      ? parseFloat(inputFeild) +
                                                        parseFloat(inputFeild) *
                                                          insurancePer
                                                      : inputFeild) ? (
                                                    <button className=" btn-buy">
                                                      Buy ${Presale?.symbol}
                                                    </button>
                                                  ) : (
                                                    <button
                                                      className="newClasss"
                                                      onClick={handlerPop}
                                                    >
                                                      Buy $
                                                      {Presale?.symbol}{" "}
                                                    </button>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {mainTag === "DOP" ? (
                                                    <>
                                                      {inputFeild == "" ||
                                                      inputFeild == null ||
                                                      inputFeild <= 0 ||
                                                      balaceOfDoppp <
                                                        (checkBoxx
                                                          ? parseFloat(
                                                              inputFeild,
                                                            ) +
                                                            parseFloat(
                                                              inputFeild,
                                                            ) *
                                                              insurancePer
                                                          : inputFeild) ? (
                                                        <button className=" btn-buy">
                                                          Buy ${Presale?.symbol}
                                                        </button>
                                                      ) : (
                                                        <button
                                                          className="newClasss"
                                                          onClick={handlerPop}
                                                        >
                                                          Buy $
                                                          {Presale?.symbol}{" "}
                                                        </button>
                                                      )}
                                                    </>
                                                  ) : (
                                                    <>
                                                      {inputFeild == "" ||
                                                      inputFeild == null ||
                                                      inputFeild <= 0 ||
                                                      gemsBalance <
                                                        (checkBoxx
                                                          ? parseFloat(
                                                              inputFeild,
                                                            ) +
                                                            parseFloat(
                                                              inputFeild,
                                                            ) *
                                                              insurancePer
                                                          : inputFeild) ? (
                                                        <button className=" btn-buy">
                                                          Buy ${Presale?.symbol}
                                                        </button>
                                                      ) : (
                                                        <button
                                                          className="newClasss"
                                                          onClick={handlerPop}
                                                        >
                                                          Buy $
                                                          {Presale?.symbol}{" "}
                                                        </button>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <button className=" btn-buy">
                              Buy ${Presale?.symbol}
                            </button>
                          )}
                        </>
                      )
                      // <button className=" newClasss" onClick={handlerPop}>Buy Do </button>
                    }
                  </>
                ) : (
                  <button className="btn-buy" onClick={() => setShow(true)}>
                    Buy ${Presale?.symbol}
                  </button>
                )}
              </div>
            ) : (
              <div className="custom-tabs">
                <Tabs
                  defaultActiveKey={tab}
                  id="uncontrolled-tab-example"
                  onSelect={tabHandler}
                >
                  <Tab eventKey="home" title="Buy Token">
                    <div className="bottom-content">
                      <div className="twice-contentt">
                        <h6 className="main-head m-0">
                          Buy ${Presale?.symbol}
                        </h6>
                        <h6 style={{ fontFamily: "hsemibold" }}>
                          Your Balance:{" "}
                          {mainTag === "ETH"
                            ? blanceOfEth > 0
                              ? blanceOfEth?.toFixed(4)
                              : "0.000"
                            : mainTag === "USDT"
                              ? balanceeUsdt > 0
                                ? balanceeUsdt?.toFixed(4)
                                : "0.000"
                              : mainTag === "USDC"
                                ? balaceOfUsdc > 0
                                  ? balaceOfUsdc?.toFixed(4)
                                  : "0.000"
                                : mainTag === "WBTC"
                                  ? balaceOfWbtc > 0
                                    ? balaceOfWbtc?.toFixed(6)
                                    : "0.000"
                                  : mainTag === "UNI"
                                    ? balaceOfUnii > 0
                                      ? balaceOfUnii?.toFixed(6)
                                      : "0.000"
                                    : mainTag === "LINK"
                                      ? balaceOfLinkk > 0
                                        ? balaceOfLinkk?.toFixed(6)
                                        : "0.000"
                                      : mainTag === "PEPE"
                                        ? balaceOfPepee > 0
                                          ? balaceOfPepee?.toFixed(6)
                                          : "0.000"
                                        : mainTag === "DOP"
                                          ? balaceOfDoppp > 0
                                            ? balaceOfDoppp?.toFixed(6)
                                            : "0.000"
                                          : mainTag === "TOMI"
                                            ? balaceOfTmi > 0
                                              ? balaceOfTmi?.toFixed(4)
                                              : "0.000"
                                            : gemsBalance > 0
                                              ? gemsBalance?.toFixed(4)
                                              : "0.000"}{" "}
                          {mainTag === "ETH"
                            ? " ETH "
                            : mainTag === "USDT"
                              ? " USDT "
                              : mainTag === "USDC"
                                ? "USDC"
                                : mainTag === "WBTC"
                                  ? "WBTC"
                                  : mainTag === "UNI"
                                    ? "UNI"
                                    : mainTag === "LINK"
                                      ? "LINK"
                                      : mainTag === "PEPE"
                                        ? "PEPE"
                                        : mainTag === "DOP"
                                          ? "DOP"
                                          : mainTag === "TOMI"
                                            ? "TOMI"
                                            : "GEMS"}
                        </h6>
                      </div>

                      <div className="parent-box">
                        <img
                          src="\assets\swap-arrow.svg"
                          alt="img"
                          className="img-fluid swap-arrow"
                        />
                        <div className="inner-box">
                          {" "}
                          <div className="left">
                            <div class="dropdown">
                              <button
                                class="dropdown-toggle"
                                type="button"
                                data-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <div className="flexset">
                                  <img
                                    src={tagImge}
                                    alt="img"
                                    className="img-fluid suxvsvsyucsusc"
                                  />
                                  <div className="text">
                                    <h6>{mainTag}</h6>
                                  </div>
                                </div>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="8"
                                  height="5"
                                  viewBox="0 0 8 5"
                                  fill="none"
                                >
                                  <path
                                    d="M7.81779 1.29713L5.9829 3.24602L4.86253 4.44207C4.38809 4.94599 3.61641 4.94599 3.14197 4.44207L0.181004 1.29713C-0.207694 0.88428 0.0723969 0.180007 0.615431 0.180007H3.82219H7.38336C7.93211 0.180007 8.20648 0.88428 7.81779 1.29713Z"
                                    fill="#02171D"
                                  />
                                </svg>
                              </button>
                              <ul class="dropdown-menu">
                                {allowedTokens.map((token) => (
                                  <li key={token.symbol}>
                                    <a
                                      className="dropdown-item gscrxcsx"
                                      onClick={() => changeTag1(token.symbol)}
                                    >
                                      <img
                                        src={
                                          tokenImages[token.symbol] ||
                                          "/assets/default.svg"
                                        } // fallback if not found
                                        alt={token.symbol}
                                        className="img-fluid"
                                      />{" "}
                                      {token.symbol}
                                    </a>
                                  </li>
                                ))}
                                {/* <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("ETH")}
                                  >
                                    <img
                                      src="/assets/eth-icon.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    ETH
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("USDT")}
                                  >
                                    <img
                                      src="/assets/usdt.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    USDT
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("USDC")}
                                  >
                                    <img
                                      src="\assets\usdc.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    USDC
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("GEMS")}
                                  >
                                    <img
                                      src="\assets\newgemslogosvg.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    GEMS
                                  </a>
                                </li> */}
                                {/* <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("WBTC")}
                                  >
                                    <img
                                      src="\assets\wbtc.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    WBTC
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("LINK")}
                                  >
                                    <img
                                      src="\assets\link.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    LINK
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("TOMI")}
                                  >
                                    <img
                                      src="\assets\tomi-icon-drop.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    TOMI
                                  </a>
                                </li>

                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("PEPE")}
                                  >
                                    <img
                                      src="\assets\pepe.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    PEPE
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("UNI")}
                                  >
                                    <img
                                      src="\assets\uniswap.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    UNI
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("DOP")}
                                  >
                                    <img
                                      src="\assets\dop.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    DOP
                                  </a>
                                </li> */}
                              </ul>
                            </div>
                          </div>
                          <div className="right">
                            <h6>
                              $
                              {inputFeild1 && inputFeild
                                ? amountInUsdt?.toLocaleString(undefined, {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 2,
                                  })
                                : "0.00"}
                            </h6>
                            {/* balanceeUsdt?.toFixed(2)?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") */}
                            <input
                              onChange={inputField1Handler}
                              value={inputFeild}
                              onWheel={(e) => e.target.blur()}
                              type="number"
                              placeholder="0.00"
                            />
                            {/* <p>0.00</p> */}
                          </div>
                        </div>
                        <div className="inner-box">
                          <div className="leftiii">
                            <img
                              src={Presale?.image}
                              alt="img"
                              className="img-fluid"
                              style={{
                                width: "35px",
                                height: "35px",
                                borderRadius: "120px",
                              }}
                            />
                            <div className="text">
                              <h6>{Presale?.name}</h6>
                              <p className="textpara">${Presale?.symbol}</p>
                            </div>
                          </div>
                          <div className="right">
                            <h6>
                              {/* Balance:{" "} */}
                              {/* <span style={{ color: "#fff" }}>
{balacefAccountTomii > 0
? balacefAccountTomii
?.toFixed(4)
: "0.000"}
</span> */}
                            </h6>
                            <input
                              onChange={inputField1Handler1}
                              value={inputFeild1}
                              disabled
                              onWheel={(e) => e.target.blur()}
                              type="number"
                              placeholder="0.00"
                            />
                            {/* <p>0.00</p> */}
                          </div>
                        </div>
                      </div>

                      {/* <div className="getinsurance-flow">
                        <img
                          src="\assets\insurance-bg.png"
                          alt="img"
                          className="img-fluid insurance-shadow"
                        />
                        <div className="left-side">
                          <div className="lefthead">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M13.5007 9.49826L13.5007 6.79987L9.38942 10.9008L6.93848 9.17174L6.93848 11.6734L9.38941 13.5202L13.5007 9.49826Z"
                                fill="#329879"
                              />
                              <path
                                d="M15.4004 5.93396L15.4004 3.68436L9.94927 0.63287L9.94927 2.88247L15.4004 5.93396Z"
                                fill="#329879"
                              />
                              <path
                                d="M4.48633 5.93396L4.48633 3.68436L9.93745 0.632871L10.8798 2.05067L9.93745 2.88248L4.48633 5.93396Z"
                                fill="#329879"
                              />
                              <path
                                d="M17.1221 10.7532L17.1221 5.93036L15.0664 5.93036L15.0664 10.7532L17.1221 10.7532Z"
                                fill="#329879"
                              />
                              <path
                                d="M2.7334 10.7532L2.7334 5.93036L4.78902 5.93036L4.78902 10.7532L2.7334 10.7532Z"
                                fill="#329879"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.26893 17.126C12.9144 15.8369 15.176 13.4242 15.0669 10.3578L17.1225 10.4369C17.2772 14.7847 14.0172 17.6273 9.95425 19.064L9.26893 17.126Z"
                                fill="#329879"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10.6333 17.126C6.98789 15.8369 4.67972 13.4241 4.7888 10.3578L2.69363 10.4369C2.53896 14.7847 5.88506 17.6273 9.948 19.064L10.6333 17.126Z"
                                fill="#329879"
                              />
                            </svg>
                            <h6 className="protecthead">Gems Protect</h6>
                          </div>
                          <p>
                            Get 75% of your purchase covered by paying just 5%
                            of the total cost.{" "}
                          </p>
                        </div>
                        <div className="right-side">
                          {!checkBoxx ? (
                            <>
                              <button
                                onClick={handleShow2Insurance1}
                                className={
                                  inputFeild
                                    ? "addinsurance-btn"
                                    : "addinsurance-btn disabled"
                                }
                                // className="addinsurance-btn"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="25"
                                  viewBox="0 0 24 25"
                                  fill="none"
                                >
                                  <path
                                    d="M9 20.5C9 21.6 8.1 22.5 7 22.5C5.9 22.5 5 21.6 5 20.5C5 19.4 5.9 18.5 7 18.5C8.1 18.5 9 19.4 9 20.5ZM17 18.5C15.9 18.5 15 19.4 15 20.5C15 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5ZM7.2 15.3V15.2L8.1 13.5H15.5C16.2 13.5 16.9 13.1 17.2 12.5L21.1 5.5L19.4 4.5L15.5 11.5H8.5L4.3 2.5H1V4.5H3L6.6 12.1L5.2 14.5C5.1 14.8 5 15.1 5 15.5C5 16.6 5.9 17.5 7 17.5H19V15.5H7.4C7.3 15.5 7.2 15.4 7.2 15.3Z"
                                    fill="#329879"
                                  />
                                </svg>{" "}
                                <>
                                  {inputFeild1 > 0 ? (
                                    <>
                                      Add for{" "}
                                      {(
                                        inputFeild * insurancePer
                                      )?.toLocaleString(undefined, {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 5,
                                      })}{" "}
                                      {mainTag}
                                    </>
                                  ) : (
                                    <>Add Gems Protect</>
                                  )}
                                </>
                              </button>
                            </>
                          ) : (
                            <>
                              <div className="insurance-added">
                                <div className="btn-added">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                  >
                                    <path
                                      d="M9 20.5C9 21.6 8.1 22.5 7 22.5C5.9 22.5 5 21.6 5 20.5C5 19.4 5.9 18.5 7 18.5C8.1 18.5 9 19.4 9 20.5ZM17 18.5C15.9 18.5 15 19.4 15 20.5C15 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5ZM7.2 15.3V15.2L8.1 13.5H15.5C16.2 13.5 16.9 13.1 17.2 12.5L21.1 5.50002L19.4 4.50002L15.5 11.5H8.5L4.3 2.50002H1V4.50002H3L6.6 12.1L5.2 14.5C5.1 14.8 5 15.1 5 15.5C5 16.6 5.9 17.5 7 17.5H19V15.5H7.4C7.3 15.5 7.2 15.4 7.2 15.3ZM18 3.30002L16.6 1.90002L11.8 6.70002L9.2 4.10002L7.8 5.50002L11.8 9.50002L18 3.30002Z"
                                      fill="#E2E9EC"
                                    />
                                  </svg>
                                  <h6>Gems Protect Added</h6>
                                </div>
                                <div
                                  className="btnnotadded"
                                  onClick={() => {
                                    setCheckBoxx(false);
                                    setCheked3(false);
                                    setCheked4(false);
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                  >
                                    <path
                                      d="M9 20.5C9 21.6 8.1 22.5 7 22.5C5.9 22.5 5 21.6 5 20.5C5 19.4 5.9 18.5 7 18.5C8.1 18.5 9 19.4 9 20.5ZM17 18.5C15.9 18.5 15 19.4 15 20.5C15 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5ZM7.2 15.3V15.2L8.1 13.5H15.5C16.2 13.5 16.9 13.1 17.2 12.5L21.1 5.50002L19.4 4.50002L15.5 11.5H8.5L4.3 2.50002H1V4.50002H3L6.6 12.1L5.2 14.5C5.1 14.8 5 15.1 5 15.5C5 16.6 5.9 17.5 7 17.5H19V15.5H7.4C7.3 15.5 7.2 15.4 7.2 15.3ZM18 3.30002L16.6 1.90002L11.8 6.70002L9.2 4.10002L7.8 5.50002L11.8 9.50002L18 3.30002Z"
                                      fill="#FC4F52"
                                    />
                                  </svg>
                                  <h6>Remove Gems Protect</h6>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div> */}
                      {role === "institution" && (
                        <div
                          className="material-textfield"
                          style={{ marginTop: "5px", marginBottom: "25px" }}
                        >
                          <input
                            onChange={inputField1Handler5}
                            value={inputFeild5}
                            onWheel={(e) => e.target.blur()}
                            type="text"
                            placeholder="Enter only ERC20 wallet address"
                          />
                          <label>
                            Enter ${Presale?.symbol} recipient wallet address
                          </label>
                        </div>
                      )}
                      <div className="bottom-text">
                        {/* <div className="inner-text">
<p>Receive:</p>
<h6>
{inputFeild1
? inputFeild1
?.toFixed(3)
: "0.00"}{" "}
TOMI
</h6>
</div>
<div className="inner-text">
<p>+{aaa / 10}% Bonus:</p>
<h6>
{inputFeild1
? ((inputFeild1 * (aaa / 10)) / 100)
?.toFixed(3)
: "0.00"}{" "}
TOMI
</h6>
</div> */}
                        {/* <div className="inner-text-bold">
                          <h6>sub Total</h6>
                          <h6>
                            {inputFeild1 && inputFeild
                              ? parseFloat((inputFeild1))
                                ?.toFixed(3)
                              : "0.00"}{" "}
                            ${Presale?.symbol}
                          </h6>
                        </div> */}
                        {/* <div className="inner-text-bold inner-text-bolddddd">
                          <div className="twice-text">
                            <h6>{round == 1 ? '20' : "7"}% Additional Tokens:</h6>
                            <p>For Golden Users </p>
                          </div>
                          <h6>
                            {stakedAmount >=  5555 ?
                              <>
                                {inputFeild1 && inputFeild
                                  ?
                                  ethValueCalcualte.toFixed(2)
                                  :
                                  "0.00"}
                              </>
                              :
                              0.00
                              // (parseFloat(inputFeild) / discountedPriceee) - parseFloat((inputFeild1))
                            }
                            {" "}${Presale?.symbol}
                          </h6>
                        </div> */}

                        <div className="inner-text-bold">
                          <h6 style={{ textAlign: "start" }}>You Receive:</h6>
                          <h6 style={{ fontFamily: "f37" }}>
                            {(stakedAmount >= 5555 &&
                              stakingData?.length > 0) ||
                            moment().isBefore(stakeEndTime1) ? (
                              <>
                                {inputFeild1 && inputFeild
                                  ? ethValueCalcualte?.toPrecision(6)
                                  : "0.00"}
                              </>
                            ) : (
                              <>
                                {inputFeild1 && inputFeild
                                  ? parseFloat(inputFeild1)?.toFixed(3)
                                  : "0.00"}
                              </>
                            )}{" "}
                            ${Presale?.symbol}
                          </h6>
                        </div>
                        <div
                          className="inner-text-bold mt-3 w-100"
                          style={{ flexDirection: "column" }}
                        >
                          {checkBoxx && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                              className="w-100 mb-3"
                            >
                              <h6
                                style={{ color: "#329879", textAlign: "start" }}
                              >
                                Gems Protect
                              </h6>
                              <h6>
                                <>
                                  {inputFeild1 && inputFeild ? (
                                    <>
                                      {(
                                        inputFeild * insurancePer
                                      )?.toLocaleString(undefined, {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 5,
                                      })}
                                    </>
                                  ) : (
                                    "0.00"
                                  )}
                                </>{" "}
                                {mainTag}
                                <span
                                  style={{
                                    fontSize: "18px",
                                    color: "#77868B",
                                    marginLeft: "5px",
                                  }}
                                >
                                  ($
                                  {inputFeild1 && inputFeild
                                    ? (
                                        amountInUsdt * insurancePer
                                      )?.toLocaleString(undefined, {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 5,
                                      })
                                    : 0.0}
                                  )
                                </span>
                              </h6>
                            </div>
                          )}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="w-100"
                          >
                            <h6 style={{ color: "#329879" }}>You Pay:</h6>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "flex-end",
                                flexDirection: "column",
                              }}
                            >
                              <h6>
                                <span
                                  style={{
                                    fontFamily: "f37",
                                    color: "#329879",
                                  }}
                                >
                                  {inputFeild1 && inputFeild ? (
                                    <>
                                      {checkBoxx
                                        ? parseFloat(
                                            parseFloat(inputFeild) +
                                              inputFeild * insurancePer,
                                          )?.toFixed(4)
                                        : parseFloat(inputFeild)?.toFixed(4)}
                                    </>
                                  ) : (
                                    "0.00"
                                  )}
                                </span>{" "}
                                <span
                                  style={{
                                    fontFamily: "f37",
                                    color: "#329879",
                                  }}
                                >
                                  {" "}
                                  {mainTag}
                                </span>{" "}
                                <span
                                  style={{
                                    fontFamily: "hregular",
                                    color: "#77868B",
                                  }}
                                >
                                  ($
                                  {inputFeild1 && inputFeild ? (
                                    <>
                                      {checkBoxx
                                        ? (
                                            amountInUsdt +
                                            amountInUsdt * insurancePer
                                          )?.toLocaleString(undefined, {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 5,
                                          })
                                        : amountInUsdt?.toLocaleString(
                                            undefined,
                                            {
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 5,
                                            },
                                          )}
                                    </>
                                  ) : (
                                    0.0
                                  )}
                                  )
                                </span>
                              </h6>
                              <p className="networkmain">
                                Network:
                                <span> Ethereum Mainnet</span>
                              </p>
                            </div>
                          </div>
                        </div>
                        {/* <div className="inner-text-bold">
                          <h6>Unlocks On:</h6>
                          <h6>
                            Q1,2024
                          </h6>
                        </div> */}

                        {/* <div className="inner-text">
                          <p>Unlock Date:</p>
                          <h6>{date}</h6>
                          <h6>Q1,2024</h6>
                        </div> */}
                      </div>
                      <div className="custom-checkboxes">
                        <div className="checkboxmainnnnnn">
                          <label class="checkbox">
                            <input
                              type="checkbox"
                              checked={checkDisclaimer}
                              onChange={handleDisclaimerCheckbox}
                            ></input>
                            <span class="checkmark"></span>
                          </label>
                          <p className="checkboxpara">
                            I have read and understood the disclaimer and hereby
                            agree to its{" "}
                            <a
                              onClick={handleShowTermsServices}
                              style={{ cursor: "pointer" }}
                            >
                              terms and conditions
                            </a>
                            .<span>*</span>
                          </p>
                        </div>
                        {attemptedDisclaimer && !readDisclaimer && (
                          <p className="error-text">
                            To continue, please open and review the Terms &
                            Conditions.
                          </p>
                        )}
                        <div className="checkboxmainnnnnn">
                          <label class="checkbox">
                            <input
                              type="checkbox"
                              checked={checkCitizenship}
                              onChange={(e) =>
                                setCheckCitizenship(e.target.checked)
                              }
                            />
                            <span class="checkmark"></span>
                          </label>
                          <p className="checkboxpara">
                            I hereby confirm that I am not a citizen of the
                            United States of America or Israel<span>*</span>
                          </p>
                        </div>
                        <div className="checkboxmainnnnnn">
                          <label class="checkbox">
                            <input
                              type="checkbox"
                              checked={checkMerketing}
                              onChange={(e) =>
                                setCheckMerketing(e.target.checked)
                              }
                            />
                            <span class="checkmark"></span>
                          </label>
                          <p className="checkboxpara">
                            I acknowledge that I may receive marketing
                            communications.
                          </p>
                        </div>
                      </div>
                      <p className="approvepara">
                        You will need to approve the transaction in your wallet.
                      </p>
                      {account ? (
                        <>
                          {!timeshow &&
                          currentTime >
                            new Date(parseInt(currentRount?.startTime)) &&
                          currentTime <
                            new Date(parseInt(currentRount?.endTime)) ? (
                            <>
                              {
                                role !== "institution" ? (
                                  <>
                                    {/* {psMaxxCap>=psmyTotlaPurchasess? */}
                                    <>
                                      {mainTag === "ETH" ? (
                                        <>
                                          {inputFeild == "" ||
                                          !canBuy ||
                                          inputFeild == null ||
                                          inputFeild <= 0 ? (
                                            <button className=" btn-buy">
                                              Buy ${Presale?.symbol}{" "}
                                            </button>
                                          ) : (
                                            <button
                                              className="newClasss"
                                              onClick={handlerPop}
                                            >
                                              Buy ${Presale?.symbol}{" "}
                                            </button>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {mainTag == "USDT" ? (
                                            <>
                                              {inputFeild == "" ||
                                              inputFeild == null ||
                                              !canBuy ||
                                              inputFeild <= 0 ? (
                                                <button className=" btn-buy">
                                                  Buy ${Presale?.symbol}
                                                </button>
                                              ) : (
                                                <button
                                                  className="newClasss"
                                                  onClick={handlerPop}
                                                >
                                                  Buy ${Presale?.symbol}{" "}
                                                </button>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {mainTag == "USDC" ? (
                                                <>
                                                  {inputFeild == "" ||
                                                  inputFeild == null ||
                                                  !canBuy ||
                                                  inputFeild <= 0 ? (
                                                    <button className=" btn-buy">
                                                      Buy ${Presale?.symbol}
                                                    </button>
                                                  ) : (
                                                    <button
                                                      className="newClasss"
                                                      onClick={handlerPop}
                                                    >
                                                      Buy $
                                                      {Presale?.symbol}{" "}
                                                    </button>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {mainTag == "WBTC" ? (
                                                    <>
                                                      {inputFeild == "" ||
                                                      inputFeild == null ||
                                                      !canBuy ||
                                                      inputFeild <= 0 ? (
                                                        <button className=" btn-buy">
                                                          Buy $
                                                          {Presale?.symbol}{" "}
                                                        </button>
                                                      ) : (
                                                        <button
                                                          className="newClasss"
                                                          onClick={handlerPop}
                                                        >
                                                          Buy $
                                                          {Presale?.symbol}{" "}
                                                        </button>
                                                      )}
                                                    </>
                                                  ) : (
                                                    <>
                                                      {mainTag == "LINK" ? (
                                                        <>
                                                          {inputFeild == "" ||
                                                          inputFeild == null ||
                                                          !canBuy ||
                                                          inputFeild <= 0 ? (
                                                            <button className=" btn-buy">
                                                              Buy $
                                                              {
                                                                Presale?.symbol
                                                              }{" "}
                                                            </button>
                                                          ) : (
                                                            <button
                                                              className="newClasss"
                                                              onClick={
                                                                handlerPop
                                                              }
                                                            >
                                                              Buy $
                                                              {
                                                                Presale?.symbol
                                                              }{" "}
                                                            </button>
                                                          )}
                                                        </>
                                                      ) : (
                                                        <>
                                                          {mainTag == "PEPE" ? (
                                                            <>
                                                              {inputFeild ==
                                                                "" ||
                                                              inputFeild ==
                                                                null ||
                                                              !canBuy ||
                                                              inputFeild <=
                                                                0 ? (
                                                                <button className=" btn-buy">
                                                                  Buy $
                                                                  {
                                                                    Presale?.symbol
                                                                  }{" "}
                                                                </button>
                                                              ) : (
                                                                <button
                                                                  className="newClasss"
                                                                  onClick={
                                                                    handlerPop
                                                                  }
                                                                >
                                                                  Buy $
                                                                  {
                                                                    Presale?.symbol
                                                                  }{" "}
                                                                </button>
                                                              )}
                                                            </>
                                                          ) : (
                                                            <>
                                                              {mainTag ==
                                                              "UNI" ? (
                                                                <>
                                                                  {inputFeild ==
                                                                    "" ||
                                                                  inputFeild ==
                                                                    null ||
                                                                  !canBuy ||
                                                                  inputFeild <=
                                                                    0 ? (
                                                                    <button className=" btn-buy">
                                                                      Buy $
                                                                      {
                                                                        Presale?.symbol
                                                                      }{" "}
                                                                    </button>
                                                                  ) : (
                                                                    <button
                                                                      className="newClasss"
                                                                      onClick={
                                                                        handlerPop
                                                                      }
                                                                    >
                                                                      Buy $
                                                                      {
                                                                        Presale?.symbol
                                                                      }{" "}
                                                                    </button>
                                                                  )}
                                                                </>
                                                              ) : (
                                                                <>
                                                                  {mainTag ==
                                                                  "DOP" ? (
                                                                    <>
                                                                      {inputFeild ==
                                                                        "" ||
                                                                      inputFeild ==
                                                                        null ||
                                                                      !canBuy ||
                                                                      inputFeild <=
                                                                        0 ? (
                                                                        <button className=" btn-buy">
                                                                          Buy $
                                                                          {
                                                                            Presale?.symbol
                                                                          }{" "}
                                                                        </button>
                                                                      ) : (
                                                                        <button
                                                                          className="newClasss"
                                                                          onClick={
                                                                            handlerPop
                                                                          }
                                                                        >
                                                                          Buy $
                                                                          {
                                                                            Presale?.symbol
                                                                          }{" "}
                                                                        </button>
                                                                      )}
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      {mainTag ==
                                                                      "TOMI" ? (
                                                                        <>
                                                                          {inputFeild ==
                                                                            "" ||
                                                                          inputFeild ==
                                                                            null ||
                                                                          !canBuy ||
                                                                          inputFeild <=
                                                                            0 ? (
                                                                            <button className=" btn-buy">
                                                                              Buy
                                                                              $
                                                                              {
                                                                                Presale?.symbol
                                                                              }
                                                                            </button>
                                                                          ) : (
                                                                            <button
                                                                              className="newClasss"
                                                                              onClick={
                                                                                handlerPop
                                                                              }
                                                                            >
                                                                              Buy
                                                                              $
                                                                              {
                                                                                Presale?.symbol
                                                                              }{" "}
                                                                            </button>
                                                                          )}
                                                                        </>
                                                                      ) : (
                                                                        <>
                                                                          {inputFeild ==
                                                                            "" ||
                                                                          inputFeild ==
                                                                            null ||
                                                                          !canBuy ||
                                                                          inputFeild <=
                                                                            0 ? (
                                                                            <button className=" btn-buy">
                                                                              Buy
                                                                              $
                                                                              {
                                                                                Presale?.symbol
                                                                              }
                                                                            </button>
                                                                          ) : (
                                                                            <button
                                                                              className="newClasss"
                                                                              onClick={
                                                                                handlerPop
                                                                              }
                                                                            >
                                                                              Buy
                                                                              $
                                                                              {
                                                                                Presale?.symbol
                                                                              }{" "}
                                                                            </button>
                                                                          )}
                                                                        </>
                                                                      )}
                                                                    </>
                                                                  )}
                                                                </>
                                                              )}
                                                            </>
                                                          )}
                                                        </>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  </>
                                ) : (
                                  <>
                                    {mainTag === "ETH" ? (
                                      <>
                                        {check ? (
                                          <>
                                            {inputFeild == "" ||
                                            inputFeild == null ||
                                            inputFeild <= 0 ||
                                            blanceOfEth <
                                              (checkBoxx
                                                ? parseFloat(inputFeild) +
                                                  parseFloat(inputFeild) *
                                                    insurancePer
                                                : inputFeild) ? (
                                              <>
                                                <button className=" btn-buy">
                                                  Buy ${Presale?.symbol}
                                                  {check}
                                                </button>
                                              </>
                                            ) : (
                                              <button
                                                className="newClasss"
                                                onClick={handlerPop}
                                              >
                                                Buy ${Presale?.symbol}{" "}
                                              </button>
                                            )}
                                          </>
                                        ) : (
                                          <button className=" btn-buy">
                                            Buy ${Presale?.symbol}
                                          </button>
                                        )}
                                      </>
                                    ) : (
                                      // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                      <>
                                        {check ? (
                                          <>
                                            {inputFeild == "" ||
                                            inputFeild == null ||
                                            inputFeild <= 0 ||
                                            balanceeUsdt <
                                              (checkBoxx
                                                ? parseFloat(inputFeild) +
                                                  parseFloat(inputFeild) *
                                                    insurancePer
                                                : inputFeild) ? (
                                              <>
                                                <button className=" btn-buy">
                                                  Buy ${Presale?.symbol}{" "}
                                                  wawwwewewew
                                                </button>
                                              </>
                                            ) : (
                                              <button
                                                className="newClasss"
                                                onClick={handlerPop}
                                              >
                                                Buy ${Presale?.symbol}{" "}
                                              </button>
                                            )}
                                          </>
                                        ) : (
                                          <button className=" btn-buy">
                                            Buy ${Presale?.symbol} adadadadadad
                                          </button>
                                        )}
                                      </>
                                    )}
                                  </>
                                )
                                // <button className=" newClasss" onClick={handlerPop}>Buy GEMS </button>
                              }
                            </>
                          ) : (
                            <button className="btn-buy">
                              Buy ${Presale?.symbol}
                            </button>
                          )}
                        </>
                      ) : (
                        <button
                          className="btn-buy"
                          onClick={() => setShow(true)}
                        >
                          Buy ${Presale?.symbol}
                        </button>
                      )}
                    </div>
                  </Tab>

                  <Tab eventKey="profile" title="Buy NFTs">
                    <DopNft
                      email={email}
                      psMaxxCap={psMaxxCap}
                      psmyTotlaPurchasess={psmyTotlaPurchasess}
                      timeshow={timeshow}
                      balaceOfWbtc={balaceOfWbtc}
                      balaceOfUsdc={balaceOfUsdc}
                      getAllowanceWbtc={getAllowanceWbtc}
                      getAllowanceUsdc={getAllowanceUsdc}
                      setShow={setShow}
                      price={price}
                      wbtcCurrentPrice={wbtcCurrentPrice}
                      ethPricevalue={ethPricevalue}
                      code={code}
                      setLoarder={setLoarder}
                      saleCurrentStaus={saleCurrentStaus}
                      currentRoundd={currentRoundd}
                      blanceOfEth={blanceOfEth}
                      balanceeUsdt={balanceeUsdt}
                      pepePrice={pepePrice}
                      tomiAllowance={tomiAllowance}
                      allowanceTpl={allowanceTpl}
                      balaceOfTmi={balaceOfTmi}
                      alowence={alowence}
                      sallowance={sallowance}
                      discoundedPriceee={discoundedPriceee}
                      tab={tab}
                      setMyPsTotlaPurchasess={setMyPsTotlaPurchasess}
                      psTotlaPurchasess={psTotlaPurchasess}
                      stakeIndex={stakeIndex}
                      stakedAmount={stakedAmount}
                      discountedPriceee={discountedPriceee}
                      round={round}
                      linkPricevalue={linkPricevalue}
                      uniPricevalue={uniPricevalue}
                      pepeAllowance={pepeAllowance}
                      linkAllowance={linkAllowance}
                      uniAllowance={uniAllowance}
                      balaceOfLinkk={balaceOfLinkk}
                      balaceOfPepee={balaceOfPepee}
                      balaceOfUnii={balaceOfUnii}
                      dopAllowance={dopAllowance}
                      balaceOfDoppp={balaceOfDoppp}
                      dopPricevalue={dopPricevalue}
                      insurancePer={insurancePer}
                      checkBoxx={checkBoxx}
                      tomiPrice={tomiPrice}
                      gemsAllowance={gemsAllowance}
                      gemsBalance={gemsBalance}
                      gemsPrice={gemsPrice}
                      allowedTokens={allowedTokens}
                      getGasFeeInUSD={getGasFeeInUSD}
                      buyingNetworkFee={buyingNetworkFee}
                      setbuyingNetworkFee={setbuyingNetworkFee}
                      stakingData={
                        (stakedAmount >= 5555 && stakingData?.length > 0) ||
                        moment().isBefore(stakeEndTime1)
                          ? true
                          : false
                      }
                    />
                  </Tab>
                </Tabs>
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />

      <Modal
        className="connectwallet-modal connectwallet-newmodal"
        show={!isVerificationDone}
        // onHide={handleCloseVerification}
        centered
        enforceFocus={false}
      >
        <Modal.Header>
          <div className="multi-steps">
            <div className="common-step">
              {account ? (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                  >
                    <rect width="30" height="30" rx="15" fill="#329879" />
                    <path
                      d="M21.1448 13.0837L21.1448 7.93555L13.3011 15.7597L8.625 12.4608L8.625 17.2336L13.3011 20.7571L21.1448 13.0837Z"
                      fill="#ECF5F9"
                    />
                  </svg>
                </>
              ) : (
                <span className={account ? "" : "active"}>1</span>
              )}
              <h6>Connect Wallet</h6>
            </div>
            <span className="middle-line"></span>
            <div className={`common-step `}>
              <span className={account ? "active" : ""}>2</span>
              <h6>Confirm Email</h6>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {!account ? (
            <div className="connect-wallet-parent">
              <div className="upper-heading">
                <h6>Connect Your Wallet</h6>
                <p>
                  Choose your preferred wallet to continue with the purchase
                </p>
              </div>
              <div className="wallets-parent">
                <button onClick={connectMetaMask1} className="d-noneformobile">
                  <img
                    src="\assets\metamask.svg"
                    alt="img"
                    className="img-fluid"
                  />{" "}
                  Metamask
                </button>
                <button onClick={trustWallet}>
                  <img
                    src="\assets\walletconnect.svg"
                    alt="img"
                    className="img-fluid"
                  />{" "}
                  WalletConnect
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="ifwalletconnected">
                <div className="left-text">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_1737_20899)">
                      <circle
                        cx="6.99963"
                        cy="6.99963"
                        r="6.99963"
                        fill="#329879"
                      />
                      <path
                        d="M5.71603 10.5958L2.63379 7.51373L3.66111 6.48641L5.71603 8.54119L10.3391 3.91797L11.3664 4.94529L5.71603 10.5958Z"
                        fill="#E2E9EC"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1737_20899">
                        <rect width="14" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <p>Wallet Connected:</p>
                </div>
                <h6>
                  {/* <img src="\assets\metamask-mini-icon.svg" alt="img" className="img-fluid" /> */}
                  {account.slice(0, 6)}...{account.slice(-4)}
                </h6>
              </div>
              {isEmailVerified && (
                <div className="continue-with-verifiedemail">
                  <div className="upper-heading">
                    <h6>Continue with verified email?</h6>
                    <p>
                      Your wallet is associated with a verified email. You'll
                      receive a confirmation there once your purchase is
                      complete
                    </p>
                  </div>
                  <div className="verifiedemail-box">
                    <div className="left-content">
                      <p>Verified Email</p>
                      <h6>{email}</h6>
                    </div>
                    <h6 className="verifiedlabel">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_1737_20947)">
                          <circle
                            cx="6.99963"
                            cy="6.99963"
                            r="6.99963"
                            fill="#329879"
                          />
                          <path
                            d="M5.71603 10.5958L2.63379 7.51373L3.66111 6.48641L5.71603 8.54119L10.3391 3.91797L11.3664 4.94529L5.71603 10.5958Z"
                            fill="#E2E9EC"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1737_20947">
                            <rect width="14" height="14" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Email Verified
                    </h6>
                  </div>
                </div>
              )}
              {!isEmailVerified && (
                <>
                  <div className="ifanother-email">
                    <div className="upper-heading">
                      <h6>Enter Your Email</h6>
                      <p>
                        Provide your email address to receive purchase
                        confirmations.
                      </p>
                    </div>
                    <div className="option-field">
                      <label>Email Address</label>
                      <input
                        type="email"
                        value={email}
                        placeholder="your@email.com"
                        onChange={handleInputMail}
                        className={!isValidMail ? "error" : ""}
                      />
                      {!isValidMail && (
                        <p className="error-text">Invalid Email</p>
                      )}
                      {isMailVerificationChecked && (
                        <a
                          href="#"
                          className={`btn-send ${
                            !isValidMail || isResendDisabled ? "disabled" : ""
                          }`}
                          onClick={handleSendCode}
                          style={{
                            pointerEvents: isResendDisabled ? "none" : "auto",
                            opacity: !isValidMail || isResendDisabled ? 0.5 : 1,
                          }}
                        >
                          {isResendDisabled
                            ? `Resend in ${resendTimer}s`
                            : codeSentOnce
                              ? "Resend "
                              : "Send Code"}
                        </a>
                      )}
                    </div>
                    {otpRequired && codeSentOnce && (
                      <div className="option-field">
                        <label>Verification Code</label>
                        <input
                          type="text"
                          value={otp}
                          onChange={(e) => {
                            setOtp(e.target.value);
                            setIsCodeValid(true);
                          }}
                          className={isCodeValid ? "" : "error"}
                          placeholder="Enter 6-digit code here"
                        />
                        {!isCodeValid && (
                          <p className="error-text">
                            Invalid email verification code
                          </p>
                        )}
                      </div>
                    )}
                    {isMailVerificationChecked &&
                      otpRequired &&
                      !codeSentOnce && (
                        <div className="email-not-veirified-error">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_1790_1877)">
                              <circle
                                cx="8.99953"
                                cy="8.99953"
                                r="8.99953"
                                fill="#FC4F52"
                              />
                              <path
                                d="M11.3328 13.091L8.89564 9.88506L6.63258 13.091H4.90918L8.00783 8.69953L5.11808 4.90918H6.8763L9.06972 7.79786L11.1413 4.90918H12.8473L10.7235 7.81456H9.08713L13.091 13.091H11.3328Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1790_1877">
                                <rect width="18" height="18" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <p>
                            This email is not verified. Please verify it to
                            continue.
                          </p>
                        </div>
                      )}
                  </div>
                  <div className="bottom-btns">
                    {codeSentOnce ? (
                      <button
                        className="btn-common"
                        disabled={!isCodeValid || otp.length <= 0}
                        style={{
                          opacity:
                            !isCodeValid || otp.length <= 0 ? "0.5" : "1",
                        }}
                        onClick={handlVerifyCode}
                      >
                        Verify
                      </button>
                    ) : (
                      <button
                        className="btn-common"
                        disabled={otpRequired}
                        style={{ opacity: otpRequired ? "0.5" : "1" }}
                        onClick={handlCheckEmailVerification}
                      >
                        Continue
                      </button>
                    )}
                  </div>
                </>
              )}
              {isEmailVerified && (
                <div className="bottom-btns">
                  <button
                    className="btn-common"
                    onClick={handleContinueWithVerifiedMail}
                  >
                    Continue with this Email
                  </button>
                  <button
                    className="btn-another"
                    onClick={handleContinueWithAnotherEmail}
                  >
                    Use a different email
                  </button>
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        className="connectwallet-modal buy-modal trx-modal"
        show={show1}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>${Presale?.symbol} Purchased</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buy-modal">
            <h4>${Presale?.symbol} Purchase Completed !</h4>
            <p>Here’s a summary of your transaction</p>
            <div className="token-purchased-area">
              <div className="single-value">
                <h5>
                  Tokens Received
                  <div className="tooltipmain">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <path
                        d="M6.99984 12.8332C10.2215 12.8332 12.8332 10.2215 12.8332 6.99984C12.8332 3.77818 10.2215 1.1665 6.99984 1.1665C3.77818 1.1665 1.1665 3.77818 1.1665 6.99984C1.1665 10.2215 3.77818 12.8332 6.99984 12.8332Z"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7 4.6665V6.99984"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7 9.3335H7.00583"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <div className="innertooltip">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="6"
                        viewBox="0 0 16 6"
                        fill="none"
                        className="arrowsvg"
                      >
                        <path
                          d="M5.36598 0.989823C6.87409 -0.329768 9.12591 -0.329767 10.634 0.989824L16 5.68506H0L5.36598 0.989823Z"
                          fill="#C0CBCF"
                        />
                      </svg>
                      Added to your wallet balance shortly after confirmation
                    </div>
                  </div>
                </h5>
                <h6>
                  {(stakedAmount >= 5555 && stakingData?.length > 0) ||
                  moment().isBefore(stakeEndTime1) ? (
                    <>
                      {inputFeild1 && inputFeild
                        ? ethValueCalcualte?.toPrecision(6)
                        : "0.00"}
                    </>
                  ) : (
                    <>
                      {inputFeild1 && inputFeild
                        ? parseFloat(inputFeild1)?.toFixed(3)
                        : "0.00"}
                    </>
                  )}{" "}
                  ${Presale?.symbol}
                </h6>
              </div>
            </div>
            <div className="token-purchased-area tokenpurchasedlast">
              {/* {checkBoxx && ( */}
              <div className="single-value">
                <h5>Token Purchase Amount</h5>
                <h6>
                  {inputFeild1 && inputFeild ? parseFloat(inputFeild) : "0.00"}{" "}
                  {mainTag}{" "}
                  <span>
                    ($
                    {inputFeild1 && inputFeild
                      ? amountInUsdt?.toLocaleString(undefined, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 5,
                        })
                      : 0.0}
                    )
                  </span>
                </h6>
              </div>
              {/* )} */}
              {checkBoxx && (
                <div className="single-value">
                  <h5>Gems Protect</h5>
                  <h6>
                    <>
                      {inputFeild1 && inputFeild ? (
                        <>
                          {(inputFeild * insurancePer)?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            },
                          )}
                        </>
                      ) : (
                        "0.00"
                      )}
                    </>{" "}
                    {mainTag}
                    <span>
                      ($
                      {inputFeild1 && inputFeild
                        ? (amountInUsdt * insurancePer)?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            },
                          )
                        : 0.0}
                      )
                    </span>
                  </h6>
                </div>
              )}
              <div
                className={
                  checkBoxx ? "single-value newborderr" : "single-value"
                }
                style={{
                  borderBottom: !checkBoxx ? "none" : "1px solid #C0CBCF",
                }}
              >
                <h5>Total Spent (incl. network fees) </h5>
                <h6 style={{ color: "#329879" }}>
                  {inputFeild1 && inputFeild ? (
                    <>
                      {checkBoxx
                        ? parseFloat(
                            parseFloat(inputFeild) + inputFeild * insurancePer,
                          )
                        : parseFloat(inputFeild)}
                    </>
                  ) : (
                    "0.00"
                  )}{" "}
                  {mainTag}{" "}
                  <span style={{ color: "#77868B" }}>
                    ($
                    {inputFeild1 && inputFeild ? (
                      <>
                        {checkBoxx
                          ? (
                              amountInUsdt +
                              amountInUsdt * insurancePer +
                              buyingNetworkFee
                            )?.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            })
                          : (amountInUsdt + buyingNetworkFee)?.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 5,
                              },
                            )}
                      </>
                    ) : (
                      0.0
                    )}
                    )
                  </span>
                </h6>
              </div>
            </div>

            <button
              className="btn-common"
              onClick={() => {
                handleClose();
                history.push("/claim?buy=true");
              }}
              style={{ marginTop: "20px" }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="stakingmodal premiumstake-modal newmodalbackdrop"
        show={show0}
        onHide={handleClos0}
        centered
        backdrop={false}
        keyboard={false}
      >
        <Modal.Body>
          <div className="stakingmodal">
            <div className="inner-content">
              <img
                src="\assets\premium\modalbg.png"
                alt="img"
                className="img-fluid modalbg-stake"
              />
              <img
                src="\assets\premium\goldenuser.svg"
                alt="img"
                className="img-fluid"
              />
              <h5>
                Get Gems Premium and <br />
                Receive {round == 1 ? "20" : "7"}% Discount
              </h5>
            </div>
            <div className="d-flex justify-content-center mb-4">
              {/* <p className="text-danger ">{walletError}</p> */}
            </div>
            <div className="stakingbtns">
              <button
                onClick={() => {
                  handleClos0();
                }}
                className="cancelbtn"
              >
                Continue
              </button>
              <button
                onClick={() => {
                  history.push("/discount");
                }}
                className="confirmbtn"
              >
                Get Gems Premium
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="connectwallet-modal nooreee learnmore-modal"
        show={show2insurance1}
        onHide={handleClose2Insurance1}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Terms & Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="disclaimerdiv">
            <div className="darktext">
              <div className="scrolltext">
                <p className="darkparaupper text-center">
                  You may choose to sign up for Gems Protect, in order to be
                  eligible to take part in Gems Protect you must:
                </p>

                <p className="darkpara">
                  <ol>
                    <li>purchase one or more {Presale?.name};</li>
                    <li>
                      deposit, claim, and trade all mined Tokens exclusively via
                      GEMS' Exchange; and
                    </li>
                    <li>
                      maintain an active account on the Exchange in all times
                      until the expiration of the {Presale?.name} product (which
                      matures within 18 months from the TGE).
                    </li>
                  </ol>
                </p>
                <p className="darkpara">
                  For the removal of any doubt any withdrawal of the Tokens from
                  the Exchange will result in an immediate cancelation of your
                  participation in the Gems Protect program.
                </p>

                <p className="darkpara">
                  Gems Protect allows you to recover up to 75% of the initial
                  purchase value of the acquired Tokens via the {Presale?.name},
                  meaning, if the total value of the {Presale?.name} that you
                  originally purchased will drop on Effective Day, we will
                  reimburse you in such way that your {Presale?.name} value will
                  increase to 75% of the initial purchase value of the acquired
                  {Presale?.name}. When calculating your P&L on Effective Day we
                  will consider the value of Tokens held by you in your account
                  with the Exchange and the ones that were sold via the
                  Exchange. We will reimburse you in USTD (or in any other
                  cryptocurrency as we see fit). The fee for participating in
                  the Gems Protect program is 5% of the value of the{" "}
                  {Presale?.name}, in case a few
                  {Presale?.name} were purchased by you, you will need to pay 5%
                  of their value in total.
                </p>

                <p className="darkpara">
                  <span className="headingtext formarginleft">
                    Gems Protect Coverage and Evaluation:
                  </span>
                  Gems Protect protection will be evaluated every month based on
                  the user's Profit & Loss (P&L) calculation. The protection
                  will expire if any of the following conditions are met:
                  <ol>
                    <li>
                      18 months have passed since the TGE, after which Gems
                      Protect is no longer valid.
                    </li>
                    <li>
                      Total rewards received from the miner exceed 75% of the
                      initial miner purchase cost. If the total value of mined
                      tokens claimed by the user (whether sold or held) reaches
                      75% of the miner's initial purchase price, Gems Protect
                      coverage terminates.
                    </li>
                    <li>
                      The value of mined tokens is double the initial miner
                      cost. If the total mined tokens (including those not yet
                      sold) reach a value of 2x the initial purchase price, Gems
                      Protect coverage terminates, as the tokens are liquid and
                      can be sold at market price.
                    </li>
                  </ol>
                </p>

                <p className="darkpara">
                  <span className="headingtext formarginleft">
                    Monthly Valuation and Calculation:
                  </span>
                </p>
                <p className="darkpara">
                  A fixed valuation date will be announced.
                </p>
                <p className="darkpara">
                  Every month, a snapshot will be taken on this date to assess
                  the user's P&L.
                </p>
                <p className="darkpara">
                  The token price will be determined using the 7-day average
                  price prior to the snapshot date.
                </p>

                <p className="darkpara">
                  The P&L calculation for the user's miners will be based on:
                </p>
                <p className="darkpara">
                  Total USDT generated from token sales by the user.
                </p>
                <p className="darkpara">
                  The total value of tokens still held, using the price
                  calculation method above.
                </p>

                <p className="darkpara">
                  Insurance Fund Allocation and Withdrawal Conditions
                </p>

                <p className="darkpara">
                  If a user qualifies for Gems Protect support in any given
                  month (i.e., their miner's total value is below 75% of the
                  initial purchase price), the calculated compensation amount
                  will be allocated to a sub-account in GEMS Exchange.
                </p>

                <p className="darkpara">
                  Users cannot withdraw these funds immediately.
                </p>

                <p className="darkpara">
                  The final Gems Protect calculation will be made only after 18
                  months, once the miner has completed its full cycle and all
                  potential earnings have been realized.
                </p>
                <p className="darkpara">
                  If, by the end of 18 months, the user's total P&L remains
                  below 75% of the initial purchase price, the accumulated Gems
                  Protect funds in the sub-account will be released for
                  withdrawal. <br /> <br />
                  If the user's P&L recovers above 75% during the 18-month
                  period, no Gems Protect funds will be paid out, even if
                  allocations were made in previous months.
                </p>
                <p className="darkpara">Reimbursement Mechanism</p>
                <p className="darkpara">
                  The preferred form of Gems Protect reimbursement is USDT.
                </p>
                <p className="darkpara">
                  In extreme cases, Gems Protect payments may be made in other
                  cryptocurrencies at our discretion.
                </p>

                <p className="darkpara">Gems Protect Participation Fee</p>
                <p className="darkpara">
                  A 5% fee of the total value of the purchased {Presale?.name}{" "}
                  will be required to enroll in Gems Protect. If multiple{" "}
                  {Presale?.name} are purchased, the fee applies to the total
                  value.
                </p>
              </div>
            </div>
            <div className="checkboxmainnnnnn">
              <label class="checkbox m-0" for="ch1">
                <input
                  type="checkbox"
                  onChange={inputField1Handler6}
                  id="ch1"
                  value={cheked3}
                  checked={cheked3}
                ></input>
                <span class="checkmark"></span>
              </label>
              <p className="checkboxpara">
                I confirm that I have read and understand the Terms & Conditions
              </p>
            </div>

            <div className="checkboxmainnnnnn">
              <label class="checkbox m-0" for="ch2">
                <input
                  type="checkbox"
                  id="ch2"
                  value={cheked4}
                  checked={cheked4}
                  onChange={inputField1Handler7}
                />
                <span class="checkmark"></span>
              </label>
              <p className="checkboxpara">I agree to the Terms & Conditions</p>
            </div>
            {/* disablebutton */}
            {cheked3 && cheked4 ? (
              <button
                className="continuebutton"
                onClick={handleClose2Insurance12}
              >
                Add Gems Protect
              </button>
            ) : (
              <button className="disablebutton">Add Gems Protect</button>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="connectwallet-modal nooreee"
        show={showtermsservices}
        onHide={handleCloseTermsServices}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              className="mr-2"
            >
              <rect y="0.5" width="24" height="24" rx="4" fill="#E88F35" />
              <path
                d="M10.0001 2.5L13.4199 4.40802L13.5063 17.6429L10.0866 15.7348L10.0001 2.5Z"
                fill="white"
              />
              <path
                d="M10.0001 17.604L13.4199 19.512L13.5063 21.604L10.0866 19.696L10.0001 17.604Z"
                fill="white"
              />
            </svg>
            Terms Of Service
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="darktext">
            <div className="scrolltext">
              <p className="darkparaupper text-center">Terms Of Service</p>
              <p className="darkpara text-center">
                Last Updated: [Septmber 10, 2024]
              </p>
              <p className="darkpara">
                1.
                <span className="headingtext formarginleft">Introduction</span>
              </p>
              <p className="darkpara">
                These Terms of Service, together with any other agreements or
                terms incorporated by reference, including our Privacy Policy
                (available here) (these “Terms”) govern your access to and use
                of the Gems platform, available at https://gems.vip/, (the
                “Platform”), owned and operated by Gems Labs Limited d/b/a Gems
                (“Gems,” “we,” “us”, or “our”) and any software, tools,
                features, or functionalities provided on or in connection with
                our services; including without limitation using our services,
                at your own discretion, to view, explore and or/purchase
                blockchain tokens (the “Tokens”) associated with various
                projects which may be made available on our Platform from time
                to time (collectively, the “Service”).{" "}
              </p>
              <p className="darkpara">
                For purposes of these Terms, “user”, “you”, and “your” mean you
                as the user of the Service. If you use the Service on behalf of
                a company or other entity then “you” includes you and that
                entity, and you represent and warrant that (a) you are an
                authorized representative of the entity with the authority to
                bind the entity to these Terms, and (b) you agree to these Terms
                on the entity’s behalf.
              </p>
              <p className="darkpara">
                BY USING THE PLATFORM AND/OR SERVICE, YOU AGREE TO BE BOUND BY
                THESE TERMS AND ALL OF THE TERMS INCORPORATED HEREIN BY
                REFERENCE. IF YOU DO NOT AGREE TO THESE TERMS, YOU MAY NOT
                ACCESS OR USE THE PLATFORM AND/OR SERVICE.
              </p>
              <p className="darkpara">
                Please refer to our Privacy Policy for information about how we
                collect, use, and share information from and/or about you (“Your
                Data”). By submitting Your Data through our Service, you agree
                to the terms of our Privacy Policy and you expressly consent to
                the collection, use, and disclosure of Your Information in
                accordance with the Privacy Policy.
              </p>
              <p className="darkpara">
                Gems is not a wallet provider, exchange, broker, dealer,
                financial institution, payments processor, money services
                business, or creditor. Gems showcases curated blockchain
                projects (each, a “Project”) and allows you to participate in
                the sale of their Tokens. We do not have custody or control over
                the Tokens or blockchains you are interacting with and we do not
                execute or effectuate purchases, transfers, or sales of Tokens.
                To use our Service, you must use a third-party wallet which
                allows you to engage in transactions on blockchains and you are
                responsible for obtaining and maintaining the security of such
                wallet and its keys.
              </p>
              <p className="darkpara">
                Gems is not a party to any agreement between you and the
                Project. You bear full responsibility for engaging with or
                purchasing of Tokens from to any Project and acquiring their
                Tokens, which in each case, may only be facilitated by acquiring
                a valid referral code from third-party promoters (each, a
                “Leader”) and we make no claims, guarantees, or recommendations
                about the identity, legitimacy, functionality, or authenticity
                of Leaders or Tokens (and any Projects or teams associated with
                such Tokens) visible on the Service.
              </p>
              <p className="darkpara">
                Because we have a growing number of services, we may, from time
                to time, provide additional terms for specific services (and
                such services are deemed part of the “Service” hereunder and
                shall also be subject to these Terms). Those additional terms
                and conditions, which are available with the relevant service,
                then become part of your agreement with us if you use those
                services. In the event of a conflict between these Terms and any
                additional applicable terms we may provide for a specific
                service, such additional terms shall control for that specific
                service.
              </p>
              <p className="darkpara">
                Gems reserves the right to change or modify these Terms at any
                time and in our sole discretion. If we make material changes to
                these Terms, we will use reasonable efforts to provide notice of
                such changes, such as by providing notice through the Platform
                or updating the “Last Updated” date at the beginning of these
                Terms. By continuing to access or use the Service, you confirm
                your acceptance of the revised Terms and all of the terms
                incorporated therein by reference effective as of the date these
                Terms are updated. It is your sole responsibility to review the
                Terms from time to time to view such changes and to ensure that
                you understand the terms and conditions that apply when you
                access or use the Service. We further reserve the right in our
                sole discretion to modify, suspend, or discontinue, temporarily
                or permanently, the Service (or any features or parts thereof)
                at any time and without liability as a result.
              </p>
              <p className="darkpara">
                2.
                <span className="headingtext formarginleft">
                  Accessing the Service
                </span>
              </p>
              <p className="darkpara">
                Your blockchain address functions as your identity on Gems.
                Accordingly, you will need a blockchain address and a
                third-party wallet to access the Service. Your account on the
                Platform (“Account”) will be associated with your linked
                blockchain address and will display the Tokens for that
                blockchain address (and, if applicable, any content associated
                with such Tokens). By using your wallet in connection with the
                Service, you agree that you are using that wallet under the
                terms and conditions of the applicable provider of the wallet.
                Wallets are not operated by, maintained by, or affiliated with
                Gems, and Gems does not have custody or control over the
                contents of your wallet and has no ability to retrieve or
                transfer its contents. Gems accepts no responsibility for, or
                liability to you, in connection with your use of a wallet and
                makes no representations or warranties regarding how the Service
                will operate with any specific wallet. You are solely
                responsible for keeping your wallet secure and you should never
                share your wallet credentials or seed phrase with anyone. If you
                discover an issue related to your wallet, please contact your
                wallet provider. Likewise, you are solely responsible for your
                Account and any associated wallet and we are not liable for any
                acts or omissions by you in connection with your Account or as a
                result of your Account or wallet being compromised. You agree to
                immediately notify us if you discover or otherwise suspect any
                security issues related to the Service or your Account, by
                sending an email to:{" "}
                <a href="mailto: Info@gems.vip">Info@gems.vip</a>.
              </p>
              <p className="darkpara">
                You also represent and warrant that you will comply with all
                applicable laws (e.g., local, state, federal and other laws) in
                connection with using the Service. In order to comply with our
                legal obligations and keep our users and platform safe, we may
                need to restrict, suspend, or terminate your access to the
                Service. You acknowledge that Gems is under no obligation to
                disclose the details of its decision to take such action with
                you.
              </p>
              <p className="darkpara">
                Without limiting the foregoing, by using the Service, you
                represent and warrant that:
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">a.</span> You are
                not, and have not been involved in any type of activity
                associated with money laundering or terror financing, nor
                violated any provision of the U.S. Foreign Corrupt Practices Act
                of 1977, as amended, the UK Bribery Act (2010), or any other
                applicable anti-corruption or anti bribery legislation, nor were
                you ever subject, to any investigation by, or have received a
                request for information from any governmental body relating to
                corruption or bribery under any statute and you hereby consent
                to Gems running any checks or enquiries with third parties and
                you waive any privacy or other right in connection therewith and
                acknowledge that any breach of this representation by you will
                entitle Gems to terminate these Terms with immediate effect;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">b.</span> You have
                carefully reviewed, understand, and accept the various risks of
                entering into these Terms, including, but not limited to, the
                risks detailed in Section 8, below;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">c.</span> You have
                not relied on any representations or warranties made by Gems or
                any representative thereof, including, but not limited to,
                conversations of any kind, whether through oral or electronic
                communication, or any whitepaper or similar document;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">d.</span> You are
                not a citizen, resident, or an entity incorporated in a
                geographic area in which the purchase, access to, or use of the
                Tokens is prohibited by applicable law, decree, regulation,
                treaty, or administrative act;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">e.</span> Neither
                you, nor any of your affiliates, shareholders, direct or
                indirect owners, or beneficiaries are located in, resident in,
                or incorporated under the laws of Afghanistan, Belarus, Burundi,
                Central African Republic, Congo (the Democratic Republic of the
                Congo), Cuba, Guinea, Guinea-Bissau, Haiti, Hong Kong, Iran,
                Iraq, the Democratic People's Republic of Korea (North Korea),
                Lebanon, Libya, Mali, Myanmar (Burma), Nicaragua, Somalia, South
                Sudan, Sudan, Syria, Taiwan, Venezuela, Western Sahara, Yemen,
                Zimbabwe; the Krim, Donetsk, Kherson and Luhansk regions of
                Ukraine, the United States of America or any jurisdiction which
                is the target of such comprehensive, country-wide or
                territory-wide Sanctions as currently apply to the
                aforementioned countries or any country or territory that has
                been designated as non-cooperative with international anti-money
                laundering principles or procedures by an intergovernmental
                group or organization, such as the Financial Action Task Force
                on Money Laundering (“FATF”) (each, a “Restricted
                Jurisdiction”).
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">f.</span> Neither
                you, nor any of your affiliates, shareholders, direct or
                indirect owners, or beneficiaries is the target of any Sanctions
                laws, regulations, embargoes, or restrictive measures (the
                “Sanctions”), as amended from time to time, administered,
                enacted, or enforced by: the United Nations, the United States
                of America, the European Union or any Member State thereof, the
                United Kingdom or the respective Governmental Authorities of any
                of the foregoing responsible for administering, enacting or
                enforcing Sanctions, including without limitation, OFAC, the US
                Department of State or the United Kingdom Treasury (the
                “Sanctions Authority”);
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">g.</span> Neither
                you, nor any of your affiliates, shareholders, direct or
                indirect owners, or beneficiaries is listed on any of the
                following lists (each a “Sanctions List”): the Consolidated
                United Nations Security Council Sanctions List; the Specially
                Designated Nationals and Blocked Persons List or the Sectoral
                Sanctions Identification List maintained by the US Office of
                Foreign Assets Control (OFAC); the Consolidated List of Persons,
                Groups and Entities subject to EU Financial Sanctions; the
                Consolidated List of Financial Sanctions Targets or List of
                persons subject to restrictive measures in view of Russia's
                actions destabilizing the situation in Ukraine, maintained by
                the United Kingdom Treasury or any similar list maintained by,
                or public announcement of sanctions made by, any other Sanctions
                Authority.;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">h.</span> Neither
                you, nor any of your affiliates, shareholders, direct or
                indirect owners, or beneficiaries is owned or controlled by, or
                acting on behalf of or for the benefit of, any person on a
                Sanctions List or who is a citizen, resident, or incorporated in
                any Restricted Jurisdiction.
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">i.</span> You
                represent to Gems that you purchase the Tokens as utility
                tokens, in order to use them in the Project upon its launch, and
                not as an investment, a security, a financial product or an
                instrument that may be expected to accrue value, have secondary
                market, be sold, traded or have any utility, usage, value or
                usability other than its utility in the Project.
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">j.</span> You
                covenant that any amounts used to purchase Tokens of the various
                Projects listed on the Platform will not be sourced from assets,
                funds, or accounts located in any Restricted Jurisdiction.
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">k.</span> You agree
                that we may, in our own discretion and in accordance with our
                internal compliance and risk management protocols, where we have
                any reason to suspect that any of the items above might not be
                accurate, take any appropriate action in connection with your
                Account, including but not limited to suspending or terminating
                the access to your Account or any use of the Service. We may
                further require you to provide any information or documentation,
                including identifying documentation about yourself, your
                Account, the funds used by you as part of the Service, and any
                other relevant information.
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">l.</span> Any
                information provided by you shall be at all times complete,
                accurate and not misleading.
              </p>

              <p className="darkpara">
                Finally, by using the Service, you understand the importance of
                DYOR – doing your own research. You bear full responsibility for
                verifying the authenticity, legitimacy, identity, and other
                details about any Token or Project that you view or otherwise
                interact with in conjunction with our Service. We make no
                claims, guarantees or recommendations about the identity,
                legitimacy, or authenticity of any Token, Project, or account on
                the Service.
              </p>
              <p className="darkpara">
                WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, YOU ASSUME ALL
                RISK AND LIABILITY FOR THE RISKS OF ENTERING INTO THESE TERMS
                AND THE RESULTS OBTAINED BY THE USE OF THE TOKENS AND REGARDLESS
                OF ANY ORAL OR WRITTEN STATEMENTS MADE BY GEMS, ANY GEMS
                ASSOCIATED PERSON OR ANY GEMS REPRESENTATIVE, INCLUDING IN THE
                FORM OF TECHNICAL ADVICE OR OTHERWISE, RELATED TO THE USE OF THE
                TOKENS.
              </p>
              <p className="darkpara">
                3.<span className="headingtext formarginleft">Ownership</span>
              </p>
              <p className="darkpara">
                The Service, including its “look and feel” (e.g., text,
                graphics, images, logos, page headers, button icons, urls, and
                scripts), proprietary content, information and other materials,
                and all content and other materials contained therein,
                including, without limitation, the Gems logo and all designs,
                text, graphics, pictures, data, software, sound files, other
                files, and the selection and arrangement thereof are the
                proprietary property of Gems or our affiliates, licensors, or
                users, as applicable, and you agree not to take any action(s)
                inconsistent with such ownership interests. We and our
                affiliates, licensors, and users, as applicable, reserve all
                rights in connection with the Service and its content,
                including, without limitation, the exclusive right to create
                derivative works.
              </p>
              <p className="darkpara">
                Gems’s name, logo, trademarks, and any Gems product or service
                names, designs, logos, and slogans are the intellectual property
                of Gems or our affiliates or licensors and may not be copied,
                imitated or used, in whole or in part, without our prior written
                permission in each instance. You may not use any metatags or
                other “hidden text” utilizing “Gems” or any other name,
                trademark or product or service name of Gems or our affiliates
                or licensors without our prior written permission. In addition,
                the “look and feel” of the Service constitutes the service mark,
                trademark or trade dress of Gems and may not be copied, imitated
                or used, in whole or in part, without our prior written
                permission.
              </p>
              <p className="darkpara">
                All other third-party trademarks, registered trademarks, and
                product names mentioned on the Service or contained in the
                content linked to or associated with any Tokens displayed on the
                Service are the property of their respective owners and may not
                be copied, imitated or used, in whole or in part, without the
                permission of the applicable intellectual property rights
                holder. Reference to any products, services, processes or other
                information by name, trademark, manufacturer, supplier or
                otherwise does not constitute or imply endorsement, sponsorship,
                or recommendation by Gems.
              </p>
              <p className="darkpara">
                To the extent You provide us any feedback, comments or
                suggestions ("Feedback"), you grant us a royalty-free, fully
                paid up, worldwide, perpetual and irrevocable license to
                incorporate the Feedback into the Services or any of our current
                or future products or services.
              </p>
              <p className="darkpara">
                Gems does not have ownership, custody, or control of Tokens or
                the smart contracts deployed by third parties. Creators of these
                Tokens or smart contracts are solely responsible for their
                operation and functionality.
              </p>
              <p className="darkpara">
                You are hereby granted a limited, nonexclusive, non
                transferable, non sublicensable, and personal license to access
                and use the Service provided, however, that such license is
                subject to your compliance with these Terms.
              </p>
              <p className="darkpara">
                The Tokens will be claimed by you at a later date, to be
                communicated via the Service. You are responsible for making the
                claim. Claims which are not claimed within a certain timeframe
                may be void. We may request additional information, as well as
                KYC, upon the claim and facilitation thereof may be contingent
                on providing such information to us or any third party, in full.
              </p>
              <p className="darkpara">
                We further reserve the right not to accept any purchase of
                Tokens which does not comply with our terms of use, or that we
                otherwise deem, at our sole and final discretion, incompatible
                with applicable laws, regulations, project requirements, carry
                high level of risk, origin from Restricted Jurisdictions or from
                Purchasers included in Sanctioned Lists. Each Purchaser may be
                required, at our sole and final discretion, to undergo a KYC
                process and to provide additional information and documents for
                such purpose, and each transaction may undergo a KYT screening.
                Users and transactions that will fail to meet our requirements
                may, at our sole discretion, not be able to claim the Tokens,
                and the funds used for the Purchase of Tokens may be confiscated
                and seized or refunded to you, at our sole discretion.
              </p>
              <p className="darkpara">
                4.
                <span className="headingtext formarginleft">
                  Third-Party Content, Agreements, and Services
                </span>
              </p>
              <p className="darkpara">
                As a web3 launch pad, Gems helps you explore and purchase
                utility Tokens to various third party blockchain Projects and
                purchase the Project’s Tokens prior to the official launch of
                the Tokens, possibly at a discounted rate compared to the
                initial launch price of the Tokens. Gems is not the issuer of
                any of the tokens sold or otherwise made available on its
                Platform (except the $GEMS token) and makes no representation
                regarding the Projects, their Tokens, their teams or anyone
                associated therewith, including any content associated with the
                project and/or the Tokens displayed on the Service, and you bear
                responsibility for verifying the legitimacy, authenticity, and
                legality of the Tokens that you purchase.
              </p>
              <p className="darkpara">
                These Terms solely govern the use of our Service. There may be
                terms and conditions that apply to the Tokens' themselves set
                directly between buyers, sellers, and/or creators with respect
                to the Token including with respect to the use of the Token
                content and rights and obligations associated with a given Token
                ("Project Terms"). For example, when you click to get more
                details about any of the Tokens visible on Gems, you may notice
                a third-party link to Project Terms governing the use of the
                Token that you will be required to comply with. Gems does not
                set the Project Terms and is not party to any such Project
                Terms, which are solely between you and the Project.
              </p>
              <p className="darkpara">
                Projects are solely responsible for determining and establishing
                the price of a Token, inclusive of any applicable tax.
              </p>
              <p className="darkpara">
                For its Service, Gems may receive certain fees. Gems does not
                set, collect, or determine other applicable costs, fees, and
                expenses associated with buying and selling a Token, including
                but not limited to any Project earnings, gas, or transaction
                fees. These costs, fees, and expenses are paid directly to the
                Project and/or the Leader, blockchain validator, or other third
                party, as applicable. Because these costs, fees, and expenses
                are not collected by Gems, it cannot refund them.
              </p>
              <p className="darkpara">
                The Service may also contain links or functionality to access or
                use third-party websites (“Third-Party Websites”) and
                applications (“Third-Party Applications”), or otherwise display,
                include, or make available content, data, information, services,
                applications, or materials from third parties (“Third-Party
                Materials”). When you click on a link to, or access and use, a
                Third-Party Website or Third-Party Application, though we may
                not warn you that you have left our Service, you are subject to
                the terms and conditions (including privacy policies) of another
                website or destination. Such Third-Party Websites, Third-Party
                applications, and Third-Party Materials are not under the
                control of Gems, and may be “open” applications for which no
                recourse is possible. Gems is not responsible or liable for any
                Third-Party Websites, Third-Party applications, and Third-Party
                Materials. Gems provides links to these Third-Party Websites and
                Third-Party applications only as a convenience and does not
                review, approve, monitor, endorse, warrant, or make any
                representations with respect to Third-Party Websites or
                Third-Party applications, or their products or services or
                associated Third-Party Materials. You use all links in
                Third-Party Websites, Third-Party applications, and Third-Party
                Materials at your own risk.
              </p>
              <p className="darkpara">
                5.
                <span className="headingtext formarginleft">
                  Communication Preferences.
                </span>
              </p>
              <p className="darkpara">
                By creating an Account, you consent to receive electronic
                communications from Gems (e.g., via email or other types of
                messages). These communications may include notices about your
                Account (e.g., transactional information) and are part of your
                relationship with us. We may also send you promotional
                communications via email we think will be of interest to you.
                You understand that you are not required to provide this consent
                as a condition of using the Service and you may opt out of these
                communications through the Service or through your mobile
                device’s operating system (with the possible exception of
                important service announcements and administrative messages) by
                following the unsubscribe instructions provided or through your
                Account settings.
              </p>
              <p className="darkpara">
                6.
                <span className="headingtext formarginleft">
                  Indemnification
                </span>
              </p>
              <p className="darkpara">
                By agreeing to these Terms and accessing the Service, you agree,
                to the fullest extent permitted by applicable law, to indemnify,
                defend, and hold harmless Gems, and our respective past,
                present, and future employees, officers, directors, contractors,
                consultants, equity holders, suppliers, vendors, service
                providers, parent companies, subsidiaries, affiliates, agents,
                representatives, predecessors, successors, and assigns
                (individually and collectively, the “Gems Parties”), from and
                against all actual or alleged claims, damages, awards,
                judgments, losses, liabilities, obligations, taxes, penalties,
                interest, fees, expenses (including, without limitation,
                attorneys’ fees and expenses), and costs (including, without
                limitation, court costs, costs of settlement, and costs of
                pursuing indemnification and insurance), of every kind and
                nature whatsoever, whether known or unknown, foreseen or
                unforeseen, matured or unmatured, or suspected or unsuspected,
                in law or equity, whether in tort, contract, or otherwise
                (collectively, “Claims”), including, but not limited to, damages
                to property or personal injury, that are caused by, arise out of
                or are related to (a) your use or misuse of the Service (b) any
                Feedback you provide, (c) your violation or breach of any term
                of these Terms or applicable law, and (d) your violation of the
                rights of or obligations to a third party, including another
                user or third party, and (e) your negligence or wilful
                misconduct. You agree to promptly notify Gems of any Claims and
                cooperate with the Gems Parties in defending such Claims. You
                further agree that the Gems Parties shall have control of the
                defense or settlement of any Claims. THIS INDEMNITY IS IN
                ADDITION TO, AND NOT IN LIEU OF, ANY OTHER INDEMNITIES SET FORTH
                IN A WRITTEN AGREEMENT BETWEEN YOU AND GEMS.
              </p>

              <p className="darkpara">
                7.<span className="headingtext formarginleft">Disclaimers</span>
              </p>
              <p className="darkpara">
                YOUR ACCESS TO AND USE OF THE SERVICE IS AT YOUR OWN RISK. YOU
                UNDERSTAND AND AGREE THAT THE SERVICE IS PROVIDED ON AN “AS IS”
                AND “AS AVAILABLE” BASIS AND GEMS EXPRESSLY DISCLAIMS WARRANTIES
                OR CONDITIONS OF ANY KIND, EITHER EXPRESS OR IMPLIED. GEMS MAKE
                NO WARRANTY OR REPRESENTATION AND DISCLAIM ALL RESPONSIBILITY
                FOR WHETHER THE SERVICE: (A) WILL MEET YOUR REQUIREMENTS; (B)
                WILL BE AVAILABLE ON AN UNINTERRUPTED, TIMELY, SECURE, OR
                ERROR-FREE BASIS; OR (C) WILL BE ACCURATE, RELIABLE, COMPLETE,
                LEGAL, OR SAFE. GEMS DISCLAIMS ALL OTHER WARRANTIES OR
                CONDITIONS, EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION,
                IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR
                A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT; (D) THAT THE
                TOKENS WILL BE SUITABLE FOR ANY PURPOSE, WILL ACCRUE OR HAVE ANY
                VALUE, ETC., OR THAT THEY WILL BE LISTED ON ANY CRYPTO EXCHANGE
                IN THE FUTURE. GEMS WILL NOT BE LIABLE FOR ANY LOSS OF ANY KIND
                FROM ANY ACTION TAKEN OR TAKEN IN RELIANCE ON MATERIAL OR
                INFORMATION, CONTAINED ON THE SERVICE. WHILE GEMS ATTEMPTS TO
                MAKE YOUR ACCESS TO AND USE OF THE SERVICE SAFE, GEMS CANNOT AND
                DOES NOT REPRESENT OR WARRANT THAT THE SERVICE, CONTENT, OR
                TOKENS, OR ANY OTHER CONTENT LINKED TO THE TOKENS OR OTHERWISE
                PROVIDED VIA ONE OF THE PROJECTS WHOSE TOKENS AER AVAILABLE FOR
                YOU TO PURCHASE VIA THE PLATFORM ARE FREE OF VIRUSES OR OTHER
                HARMFUL COMPONENTS. WE CANNOT GUARANTEE THE SECURITY OF ANY DATA
                THAT YOU DISCLOSE ONLINE. NO ADVICE OR INFORMATION, WHETHER ORAL
                OR OBTAINED FROM THE GEMS PARTIES OR THROUGH THE SERVICE, WILL
                CREATE ANY WARRANTY OR REPRESENTATION NOT EXPRESSLY MADE HEREIN.
                YOU ACCEPT THE INHERENT SECURITY RISKS OF PROVIDING INFORMATION
                AND DEALING ONLINE OVER THE INTERNET AND WILL NOT HOLD GEMS
                RESPONSIBLE FOR ANY BREACH OF SECURITY.
              </p>
              <p className="darkpara">
                WE WILL NOT BE RESPONSIBLE OR LIABLE TO YOU FOR ANY LOSS AND
                TAKE NO RESPONSIBILITY FOR, AND WILL NOT BE LIABLE TO YOU FOR,
                ANY USE OF OR LOSS OF USE OF TOKENS, CONTENT, AND/OR CONTENT
                LINKED TO OR ASSOCIATED WITH OR OTHERWISE PROVIDED VIA ONE OF
                THE PROJECTS WHOSE TOKENS ARE AVAILABLE FOR YOU TO PURCHASE VIA
                THE PLATFORM, INCLUDING BUT NOT LIMITED TO ANY LOSSES, DAMAGES,
                OR CLAIMS ARISING FROM: (A) USER ERROR, INCORRECTLY CONSTRUCTED
                TRANSACTIONS, OR MISTYPED ADDRESSES; (B) SERVER FAILURE OR DATA
                LOSS; (C) UNAUTHORIZED ACCESS OR USE; (D) ANY UNAUTHORIZED
                THIRD-PARTY ACTIVITIES, INCLUDING WITHOUT LIMITATION THE USE OF
                VIRUSES, PHISHING, BRUTEFORCING OR OTHER MEANS OF ATTACK AGAINST
                THE SERVICE OR TOKENS.
              </p>
              <p className="darkpara">
                NO GEMS PARTY IS RESPONSIBLE OR LIABLE FOR ANY SUSTAINED LOSSES
                OR INJURY DUE TO VULNERABILITY OR ANY KIND OF FAILURE, ABNORMAL
                BEHAVIOR OF SOFTWARE (E.G., WALLET, SMART CONTRACT), BLOCKCHAINS
                OR ANY OTHER FEATURES OF THE TOKENS. NO GEMS PARTY IS
                RESPONSIBLE FOR LOSSES OR INJURY DUE TO LATE REPORTS BY
                DEVELOPERS OR REPRESENTATIVES (OR NO REPORT AT ALL) OF ANY
                ISSUES WITH THE BLOCKCHAIN SUPPORTING THE TOKENS, INCLUDING
                FORKS, TECHNICAL NODE ISSUES OR ANY OTHER ISSUES HAVING LOSSES
                OR INJURY AS A RESULT.
              </p>
              <p className="darkpara">
                Some jurisdictions do not allow the exclusion of implied
                warranties in contracts with consumers, so the above exclusion
                may not apply to you.
              </p>
              <p className="darkpara">
                8.
                <span className="headingtext formarginleft">
                  Assumption of Risk.
                </span>
              </p>
              <p className="darkpara">You accept and acknowledge, that:</p>
              <p className="darkpara">
                <span className="headingtext formarginleft">a.</span> The value
                of a Token is subjective. Prices of Tokens are subject to
                volatility and fluctuations in the price of cryptocurrency can
                also materially and adversely affect Token prices. You
                acknowledge that you fully understand this subjectivity and
                volatility and that you may lose money.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">b.</span> You are
                responsible for any fees related to use of the Service, if any,
                including for actions you take on the blockchain, regardless of
                whether a successful transaction occurs, and that such fees are
                final and irreversible.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">c.</span> A lack of
                use or public interest in the creation and development of
                distributed ecosystems could negatively impact the development
                of those ecosystems and related applications, and could
                therefore also negatively impact the potential utility of the
                Tokens.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">d.</span> The
                regulatory regime governing blockchain technologies, tokens,
                cryptocurrency, and other crypto-based items is uncertain, and
                new regulations or policies may materially adversely affect the
                development of the Service and the utility of the Tokens.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">e.</span> You are
                solely responsible for determining what, if any, taxes apply to
                your transactions and to withhold, collect, report, and remit
                the correct amounts of taxes to the appropriate tax authorities.
                Gems is not responsible for determining, withholding,
                collecting, reporting, or remitting any taxes that apply to your
                Tokens or the sale/purchase thereof.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">f.</span> We do not
                have ownership or control of the smart contracts deployed by
                third parties, and are not responsible and make no guarantees
                regarding their operation and functionality.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">g.</span> We do not
                control the public blockchains that you are interacting with and
                we do not control certain smart contracts and protocols that may
                be integral to your ability to complete transactions on these
                public blockchains. Additionally, blockchain transactions are
                irreversible and Gems has no ability to reverse any transactions
                on the blockchain.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">h.</span> There are
                risks associated with using Internet and blockchain based
                products, including, but not limited to, the risk associated
                with hardware, software, and Internet connections, the risk of
                malicious software introduction, and the risk that third parties
                may obtain unauthorized access to your third-party wallet or
                Account. You accept and acknowledge that Gems will not be
                responsible for any communication failures, disruptions, errors,
                distortions or delays you may experience when using the Service
                or any Blockchain network, however caused.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">i.</span> The
                Service may rely on third-party platforms and/or vendors. If we
                are unable to maintain a good relationship with such platform
                providers and/or vendors; if the terms and conditions or pricing
                of such platform providers and/or vendors change; if we violate
                or cannot comply with the terms and conditions of such platforms
                and/or vendors; or if any of such platforms and/or vendors loses
                market share or falls out of favor or is unavailable for a
                prolonged period of time, access to and use of the Service may
                be directly affected.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">j.</span>IF YOU HAVE
                A DISPUTE WITH ANY LEADERS OR PROJECT TEAM, YOU RELEASE US FROM
                CLAIMS, DEMANDS, AND DAMAGES OF EVERY KIND AND NATURE, KNOWN AND
                UNKNOWN, ARISING OUT OF OR IN ANY WAY CONNECTED WITH SUCH
                DISPUTES. IN ENTERING INTO THIS RELEASE YOU EXPRESSLY WAIVE ANY
                PROTECTIONS (WHETHER STATUTORY OR OTHERWISE) THAT WOULD
                OTHERWISE LIMIT THE COVERAGE OF THIS RELEASE TO INCLUDE THOSE
                CLAIMS WHICH YOU MAY KNOW OR SUSPECT TO EXIST IN YOUR FAVOR AT
                THE TIME OF AGREEING TO THIS RELEASE.
              </p>
              <p className="darkpara">
                9.
                <span className="headingtext formarginleft">
                  Limitation of Liability.
                </span>
              </p>
              <p className="darkpara">
                TO THE FULLEST EXTENT PERMITTED BY LAW, YOU AGREE THAT IN NO
                EVENT WILL GEMS BE LIABLE TO YOU OR ANY THIRD PARTY (A) FOR ANY
                LOST PROFIT OR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY,
                INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES ARISING FROM THESE
                TERMS OR THE SERVICE, PRODUCTS OR THIRD-PARTY SITES AND
                PRODUCTS, OR FOR ANY DAMAGES RELATED TO LOSS OF REVENUE, LOSS OF
                PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE,
                LOSS OF GOODWILL, OR LOSS OF DATA, AND WHETHER CAUSED BY STRICT
                LIABILITY OR TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT, OR
                OTHERWISE, EVEN IF FORESEEABLE AND EVEN IF GEMS OR ITS SERVICE
                PROVIDERS HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES;
                OR (B) FOR ANY OTHER CLAIM, DEMAND, OR DAMAGES WHATSOEVER
                RESULTING FROM OR ARISING OUT OF OR IN CONNECTION WITH THESE
                TERMS OF THE DELIVERY, USE, OR PERFORMANCE OF THE SERVICE.
              </p>
              <p className="darkpara">
                NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, TO
                THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT SHALL THE
                MAXIMUM AGGREGATE LIABILITY OF GEMS ARISING OUT OF OR IN ANY WAY
                RELATED TO THESE TERMS, THE ACCESS TO AND USE OF THE SERVICE,
                EXCEED THE AMOUNT RECEIVED BY GEMS FOR ITS SERVICE TO YOU
                DIRECTLY RELATING TO THE ITEMS THAT ARE THE SUBJECT OF THE
                CLAIM. THE FOREGOING LIMITATIONS WILL APPLY EVEN IF THE ABOVE
                STATED REMEDY FAILS OF ITS ESSENTIAL PURPOSE.
              </p>
              <p className="darkpara">
                10.
                <span className="headingtext formarginleft">Termination</span>
              </p>
              <p className="darkpara">
                If you breach any of the provisions of these Terms, all licenses
                granted by Gems will terminate automatically. Additionally,
                notwithstanding anything contained in these Terms, we reserve
                the right, with or without notice and in our sole discretion, to
                suspend, restrict, disable, terminate, or delete your Account
                and/or your ability to access or use the Service (or any part of
                the foregoing) at any time and for any or no reason, and you
                acknowledge and agree that we shall have no liability or
                obligation to you in such event and that you will not be
                entitled to a refund of any amounts that you have already paid
                to us. If we terminate your Account or restrict your access or
                use of the Service, you retain ownership of your Tokens. You may
                still access your Tokens through public blockchains and other
                web3 wallets, platforms, and/or websites. All sections which by
                their nature should survive the termination of these Terms shall
                continue in full force and effect subsequent to and
                notwithstanding any termination of these Terms by Gems or you.
                Termination will not limit any of Gems’s other rights or
                remedies at law or in equity. You agree that a breach of these
                Terms will cause irreparable injury to Gems for which monetary
                damages would not be an adequate remedy and Gems shall be
                entitled to equitable relief in addition to any remedies it may
                have hereunder or at law without a bond, other security, or
                proof of damages.
              </p>
              <p className="darkpara">
                11.<span className="headingtext formarginleft">General</span>
              </p>
              <p className="darkpara">
                These Terms are governed by the laws of Hong Kong, excluding
                rules as to choice and conflicts of law and the competent courts
                in Hong Kong will have exclusive jurisdiction. If any part of
                these Terms is deemed unlawful, void or for any reason
                unenforceable, then that provision shall be deemed to be
                severable from the rest of these Terms and shall not affect the
                validity and enforceability of any of the remaining provisions
                of these Terms. In such cases, the part deemed invalid or
                unenforceable shall be construed in a manner consistent with
                applicable law to reflect, as closely as possible, the original
                intent of the parties. No waiver by us of a breach of any of the
                provisions of terms of these Terms shall be construed as a
                waiver of any preceding or succeeding breach of any of the
                provisions of these Terms. Nothing in these Terms shall be
                construed as creating any agency, partnership, trust
                arrangement, fiduciary relationship or any other form of joint
                enterprise between you and Gems. These Terms contain the entire
                agreement between Gems and you relating to your use of the
                Services and supersedes any and all prior agreements between
                Gems and you in relation to the same. You confirm that, in
                agreeing to accept these Terms, you have not relied on any
                representation except as has expressly been made by Gems in
                these Terms. You may not assign your rights or delegate your
                obligations under these Terms without Gems’ prior written
                consent. Any purported assignment contrary to this section will
                be null and void. Gems may assign its obligations hereunder.
                Except as otherwise provided herein, these Terms are intended
                solely for the benefit of the parties and are not intended to
                confer third-party beneficiary rights upon any other person or
                entity.
              </p>
              <p className="darkpara">
                In addition to the implementation of KYT (Know Your
                Transaction), a KYB (Know Your Business) process will also be
                enacted, facilitated by a trusted third-party service provider.
                This process will ensure thorough business verification for all
                entities interacting with the platform, supporting our
                compliance with international regulations. Furthermore, any
                funds or transactions received from jurisdictions classified as
                "blacklisted" or high-risk countries will be subject to enhanced
                scrutiny, including the reporting of any suspicious activities
                or transactions to the relevant authorities.
              </p>
            </div>
          </div>
          <button className="continuebutton" onClick={handleCloseTermsServices}>
            Close
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Banner;
